// Handles a POST /login request
import {graphql, rest} from "msw";
import {jurisdictionList} from "./DataSets/jurisdiction";
import {propertyList} from "./DataSets/properties";

export const all = (activeRoles) => [
  MockUserQuery(activeRoles),
  MockLogin(),
  MockGetQueueItemsShort(),
  MockGetClaimedQueueItems(),
  MockGetResearchQueueItemsShort(),
  MockGetResearchClaimedQueueItems(),
  MockGetReportItem(),
  MockGetProperty(),
  MockGetZonesForJurisdiction(),
  MockGetMediaImages(),
  MockGetJurisdiction(),
  MockGetMediaDocuments(),
  MockGetBvViolations(),
  MockGetDocumentTypes(),
  MockProperties(),
  MockResidentialOrders(),
  MockGetUsesForJurisdiction(),
  MockGetResearchDocuments(),
  MockGetTenants(),
  MockGetCommercialQueueItems(),
  MockGetCommercialClaimedQueueItems(),
  MockGetCommercialReportItem(),
  MockGetCommercialOrder(),
  MockLogo(),
  MockGetJurisdictions(),

  //mutations
  MockClaimResearchQueueItem(),
  MockEditOrderItem(),
  MockCreateProperty(),
  MockEditProperty(),
  MockEditJurisdiction(),
  MockGenerateCommercialReport(),
];

export const MockLogin = () => rest.post('http://loginMocked', (req, res, ctx) => {
  return res(
    ctx.json({
      "token_type":"Bearer",
      "expires_in":86400,
      "access_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjczZTBiZWY0ZjBkNmU2NzRjYmVjZDdmNTQ2ODNkMWU4MmMzYmNlZjRlMTIwMWJkN2Y4M2FiODg0YzVkYjQ1MDA1NjhjOGJmZjdmN2UzYzFiIn0.eyJhdWQiOiI3MDZhY2QzNy1iZGNiLTQyM2EtYjhjMy1iZDZjNGUxNDA0ODgiLCJqdGkiOiI3M2UwYmVmNGYwZDZlNjc0Y2JlY2Q3ZjU0NjgzZDFlODJjM2JjZWY0ZTEyMDFiZDdmODNhYjg4NGM1ZGI0NTAwNTY4YzhiZmY3ZjdlM2MxYiIsImlhdCI6MTY1NzAyOTc1OCwibmJmIjoxNjU3MDI5NzU4LCJleHAiOjE2NTcxMTYxNTgsInN1YiI6IjEiLCJzY29wZXMiOlsiYXV0aGVudGljYXRlZCIsImFuYWx5c3QiLCJhcHBfdXNlciIsImN1c3RvbWVyIiwiZGF0YV9lbnRyeV8xIiwiZGF0YV9lbnRyeV8yIiwiZGF0YV9lbnRyeV8zIiwianVuaW9yX2FuYWx5c3QiLCJyZXNlYXJjaCJdfQ.UFLnYF57Q7u9Ts16agwpmfGYHYtp_4IWwggSz_70q4H7NzLoVmEtF4oNLJ6QxrmITtETKyKOqwDeo3wp_9lUsUHlmWpOQxqC-gwmAgKOISozpWMf7VhP1n_NWtY_FCFOgMIW_I9_K1cV-Cc87LSRWqsDe6NkdJsSHXW5GOt2XY3qng9j6bVjlp7siXjY8YVVjOOMEv7zWw4e2eJRVHOsss0PO1SR-g7x5yQeoXQmJZH6jxYx2fJqGFN98TWPeGTqP3UV0OYgifvoefis6M413CA__2uxlvUdJ0w_s5bpCFRzw-Z7I9rEETLyzljNDCE-oKSBOhn51VtjBgJfcsApieO9PaKotcuD2eE_PLCG07pr-ZvffZgmSKOPQZFJNs5ur4EtGhxEETqw1GzHm6CVYAAlQlas0W5uvWFxJN_LywFA-EotAQREKQbm-feuROhErKOeKKuOu62uFZhcXAu0tQWQUmyt0BcQOZc-DGU50-NZImfyBAshflbtJmJHnxTAnqKs-dWiVnrJqTPmnkDpfozY2I57J0e3GXIHSw62JluJPNrDo_zgcgAc00752aSgO4YsQXVIdmPHYLnkNCp_1N9tJYKe1BsERnTYgZk6IuNgTf1M_qGeAaHpRQE68FCZvsixrz9cPkqmlGcgRS-LnAHQ0HHe_tpbiOng_GD-wsY","refresh_token":"def502009f0c90a10afd795c4f27ef438ae5f0e0db3acc1277d2c56de760f01b5451977443e27fefa28875778af6dc5b80543509dc07e2862e03fb760f2202cc3c24707248f6feccb052fb3fd1988b64b798e63e524d17cacba13b9f9a411f445730a0fbe213a09f3c75a1cc9aad33a6013e7e9879a750241c79e9922079461211d766f8efd162200a3f34d5552849c4503f041b145c98ffdb9bfb848b2194c49cb7e4d00cdbb4895aefebcd41fdb5a964fed46df287f2c7dd93f87ad3cefcd2f4cdf31a0a564ab2689d681127c60afe76cd765bf66fc83471d2fe9da990f692cf9657000dc6db60f13d67b04624d2899f901d86b2af7011db3856edc125b99a92c7788227546b939afe7a9ff2d89b8fa596e74270536cee5f11f6934a3a1bf19e6d66828de6f19111a20cde3139ac2a13ad3b8513c9bb16551426aa418d1c2031735c072c78fdf1a81929ae9a4915720903501deeaa44325c249086a9d251eeb02fa48a197edb992150b04a8aa36cb71eaab6aa687ceb0c2bc8717bf2c82fb8e956dce87a580be87a7a279b6239c8b8fb701f4c2e29adae46b93afde25e706c06474ee14b91cdb48cb69aa89aa72293966b583401f12f51e5a95a7d5f8a8c0110bc722738a24a02f88f4192b44f683e48fb300ca44b82c862970cc2ed76a3ac120240b11b0e7414792dcd111da8885d8feb3a51ad3f70248fe10be2a9b2"
    }),
  )
});

export const MockLogo = () => rest.get('/logo192.png', (req, res, ctx) => {
  return res(
    ctx.json({
      "token_type":"Bearer",
      "expires_in":86400,
      "access_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjczZTBiZWY0ZjBkNmU2NzRjYmVjZDdmNTQ2ODNkMWU4MmMzYmNlZjRlMTIwMWJkN2Y4M2FiODg0YzVkYjQ1MDA1NjhjOGJmZjdmN2UzYzFiIn0.eyJhdWQiOiI3MDZhY2QzNy1iZGNiLTQyM2EtYjhjMy1iZDZjNGUxNDA0ODgiLCJqdGkiOiI3M2UwYmVmNGYwZDZlNjc0Y2JlY2Q3ZjU0NjgzZDFlODJjM2JjZWY0ZTEyMDFiZDdmODNhYjg4NGM1ZGI0NTAwNTY4YzhiZmY3ZjdlM2MxYiIsImlhdCI6MTY1NzAyOTc1OCwibmJmIjoxNjU3MDI5NzU4LCJleHAiOjE2NTcxMTYxNTgsInN1YiI6IjEiLCJzY29wZXMiOlsiYXV0aGVudGljYXRlZCIsImFuYWx5c3QiLCJhcHBfdXNlciIsImN1c3RvbWVyIiwiZGF0YV9lbnRyeV8xIiwiZGF0YV9lbnRyeV8yIiwiZGF0YV9lbnRyeV8zIiwianVuaW9yX2FuYWx5c3QiLCJyZXNlYXJjaCJdfQ.UFLnYF57Q7u9Ts16agwpmfGYHYtp_4IWwggSz_70q4H7NzLoVmEtF4oNLJ6QxrmITtETKyKOqwDeo3wp_9lUsUHlmWpOQxqC-gwmAgKOISozpWMf7VhP1n_NWtY_FCFOgMIW_I9_K1cV-Cc87LSRWqsDe6NkdJsSHXW5GOt2XY3qng9j6bVjlp7siXjY8YVVjOOMEv7zWw4e2eJRVHOsss0PO1SR-g7x5yQeoXQmJZH6jxYx2fJqGFN98TWPeGTqP3UV0OYgifvoefis6M413CA__2uxlvUdJ0w_s5bpCFRzw-Z7I9rEETLyzljNDCE-oKSBOhn51VtjBgJfcsApieO9PaKotcuD2eE_PLCG07pr-ZvffZgmSKOPQZFJNs5ur4EtGhxEETqw1GzHm6CVYAAlQlas0W5uvWFxJN_LywFA-EotAQREKQbm-feuROhErKOeKKuOu62uFZhcXAu0tQWQUmyt0BcQOZc-DGU50-NZImfyBAshflbtJmJHnxTAnqKs-dWiVnrJqTPmnkDpfozY2I57J0e3GXIHSw62JluJPNrDo_zgcgAc00752aSgO4YsQXVIdmPHYLnkNCp_1N9tJYKe1BsERnTYgZk6IuNgTf1M_qGeAaHpRQE68FCZvsixrz9cPkqmlGcgRS-LnAHQ0HHe_tpbiOng_GD-wsY","refresh_token":"def502009f0c90a10afd795c4f27ef438ae5f0e0db3acc1277d2c56de760f01b5451977443e27fefa28875778af6dc5b80543509dc07e2862e03fb760f2202cc3c24707248f6feccb052fb3fd1988b64b798e63e524d17cacba13b9f9a411f445730a0fbe213a09f3c75a1cc9aad33a6013e7e9879a750241c79e9922079461211d766f8efd162200a3f34d5552849c4503f041b145c98ffdb9bfb848b2194c49cb7e4d00cdbb4895aefebcd41fdb5a964fed46df287f2c7dd93f87ad3cefcd2f4cdf31a0a564ab2689d681127c60afe76cd765bf66fc83471d2fe9da990f692cf9657000dc6db60f13d67b04624d2899f901d86b2af7011db3856edc125b99a92c7788227546b939afe7a9ff2d89b8fa596e74270536cee5f11f6934a3a1bf19e6d66828de6f19111a20cde3139ac2a13ad3b8513c9bb16551426aa418d1c2031735c072c78fdf1a81929ae9a4915720903501deeaa44325c249086a9d251eeb02fa48a197edb992150b04a8aa36cb71eaab6aa687ceb0c2bc8717bf2c82fb8e956dce87a580be87a7a279b6239c8b8fb701f4c2e29adae46b93afde25e706c06474ee14b91cdb48cb69aa89aa72293966b583401f12f51e5a95a7d5f8a8c0110bc722738a24a02f88f4192b44f683e48fb300ca44b82c862970cc2ed76a3ac120240b11b0e7414792dcd111da8885d8feb3a51ad3f70248fe10be2a9b2"
    }),
  )
});

// eslint-disable-next-line no-unused-vars
export const MockGetQueueItemsShort = () => graphql.query('getQueueItemsShort', (req, res, ctx) => {
  return res(
    ctx.data(
      {"queueItems":{
          "items": jurisdictionList,"total":50,"__typename":"JurisdictionSelectConnection"
      }})
  )
});

export const MockUserQuery = (activeRoles) => graphql.query('UserQuery', (req, res, ctx) => {
  return res(
    ctx.data({
      "currentUser":{
        "id":1,
        "mail":"zac@worxco.net",
        "name":"admin",
        "roles": activeRoles,
        "__typename":"User"
      }
    })
  )
});

export const MockGetClaimedQueueItems = () => graphql.query('getClaimedQueueItems', (req, res, ctx) => {
  const { queue } = req.variables;

  switch (queue) {
    case 'main_workflow':
      return res(
        ctx.data({"claimedQueueItems":{"items":[
              jurisdictionList[5],
              jurisdictionList[8],
              jurisdictionList[13],
              jurisdictionList[20],
              jurisdictionList[21],
            ],"total":5,"__typename":"JurisdictionSelectConnection"}}
        )
      )
    case 'use_workflow':
      return res(
        ctx.data({"claimedQueueItems":{"items":[
              {"id":20725,"name":"Brookfield - Cook - Illinois","type":"locality","__typename":"Locality"},
              {"id":20726,"name":"Buffalo Grove - Lake - Illinois","type":"locality","__typename":"Locality"},
              {"id":2711,"name":"Glynn - Georgia","type":"subdivision","__typename":"Subdivision"},
              {"id":955,"name":"Coos - Oregon","type":"subdivision","__typename":"Subdivision"},
              {"id":20727,"name":"Abington - Montgomery - Pennsylvania","type":"locality","__typename":"Locality"}
            ],"total":5,"__typename":"JurisdictionSelectConnection"}}
        )
      )
    case 'requirements_workflow':
      return res(
        ctx.data({"claimedQueueItems":{"items":[
              {"id":20725,"name":"Brookfield - Cook - Illinois","type":"locality","__typename":"Locality"},
              {"id":20726,"name":"Buffalo Grove - Lake - Illinois","type":"locality","__typename":"Locality"},
              {"id":2711,"name":"Glynn - Georgia","type":"subdivision","__typename":"Subdivision"},
              {"id":955,"name":"Coos - Oregon","type":"subdivision","__typename":"Subdivision"},
              {"id":20727,"name":"Abington - Montgomery - Pennsylvania","type":"locality","__typename":"Locality"}
            ],"total":5,"__typename":"JurisdictionSelectConnection"}}
        )
      )
    }
});

/*graphql.query('getClaimedQueueItems', (req, res, ctx) => {
  return res(
    ctx.data({"claimedQueueItems":{"items":[
          {"id":20725,"name":"Brookfield - Cook - Illinois","type":"locality","__typename":"Locality"},
          {"id":20726,"name":"Buffalo Grove - Lake - Illinois","type":"locality","__typename":"Locality"},
          {"id":2711,"name":"Glynn - Georgia","type":"subdivision","__typename":"Subdivision"},
          {"id":955,"name":"Coos - Oregon","type":"subdivision","__typename":"Subdivision"},
          {"id":20727,"name":"Abington - Montgomery - Pennsylvania","type":"locality","__typename":"Locality"}
        ],"total":5,"__typename":"JurisdictionSelectConnection"}}
    )
  )
})*/

export const MockGetResearchQueueItemsShort = () => graphql.query('getResearchQueueItemsShort', (req, res, ctx) => {
  const { limit, offset } = req.variables;

  let items = [
    {
    "id": 42,
    "name": " 3111 North Tustin Avenue",
    "order": [{
      "id": 9,
      "portfolio_name": " 3111 North Tustin Avenue",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "working",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 3327,
      "name": "Orange - Orange - California",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20704937,
      "name": " 3111 North Tustin Avenue",
      "address": {
        "address_line1": "3111 N Tustin Ave",
        "address_line2": "",
        "administrative_area": "CA",
        "country_code": "US",
        "locality": "Orange",
        "postal_code": "92865",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 1,
    "name": "3000 FM 646 East",
    "order": [{
      "id": 1,
      "portfolio_name": " League City Storage",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "working",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 8833,
      "name": "League City - Galveston - Texas",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 17797374,
      "name": "3000 FM 646 East",
      "address": {
        "address_line1": "3000 FM 646 East",
        "address_line2": "",
        "administrative_area": "TX",
        "country_code": "US",
        "locality": "League City",
        "postal_code": "77573",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 69,
    "name": "2311 ANZIO DR",
    "order": [{
      "id": 18,
      "portfolio_name": "Wynnewood Gardens",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 8406,
      "name": "Dallas - Dallas - Texas",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 2807532,
      "name": "2311 ANZIO DR",
      "address": {
        "address_line1": "2311 ANZIO DR",
        "address_line2": "",
        "administrative_area": "TX",
        "country_code": "US",
        "locality": "Dallas",
        "postal_code": "75001",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 73,
    "name": "3001 KENDALE DR",
    "order": [{
      "id": 19,
      "portfolio_name": "Pecan Tree",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 8406,
      "name": "Dallas - Dallas - Texas",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 2845976,
      "name": "3001 KENDALE DR",
      "address": {
        "address_line1": "3001 KENDALE DR",
        "address_line2": "",
        "administrative_area": "TX",
        "country_code": "US",
        "locality": "Dallas",
        "postal_code": "75001",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 77,
    "name": "10001 N CENTRAL EXPY",
    "order": [{
      "id": 20,
      "portfolio_name": "La Quinta",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 8406,
      "name": "Dallas - Dallas - Texas",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 2713732,
      "name": "10001 N CENTRAL EXPY",
      "address": {
        "address_line1": "10001 N CENTRAL EXPY",
        "address_line2": "",
        "administrative_area": "TX",
        "country_code": "US",
        "locality": "Dallas",
        "postal_code": "75001",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 81,
    "name": "4410 N 99th Ave",
    "order": [{
      "id": 21,
      "portfolio_name": null,
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 6665,
      "name": "Phoenix - Maricopa - Arizona",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20714395,
      "name": "4410 N 99th Ave",
      "address": {
        "address_line1": "4410 N 99th Ave",
        "address_line2": "",
        "administrative_area": "AZ",
        "country_code": "US",
        "locality": "Phoenix",
        "postal_code": "85037",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 89,
    "name": "1421 Olentangy River Rd",
    "order": [{
      "id": 22,
      "portfolio_name": null,
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "working",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 19350,
      "name": "Columbus - Franklin - Ohio",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20714396,
      "name": "1421 Olentangy River Rd",
      "address": {
        "address_line1": "1421 Olentangy River Rd",
        "address_line2": "",
        "administrative_area": "OH",
        "country_code": "US",
        "locality": "columbus",
        "postal_code": "43212",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 95,
    "name": "1603 E OLTORF ST",
    "order": [{
      "id": 23,
      "portfolio_name": " 1603 East Oltorf Street",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 9681,
      "name": "Austin - Travis - Texas",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 222858,
      "name": "1603 E OLTORF ST",
      "address": {
        "address_line1": "1603 E OLTORF ST",
        "address_line2": "",
        "administrative_area": "TX",
        "country_code": "US",
        "locality": "Austin",
        "postal_code": "78613",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 99,
    "name": "6301 BERKMAN DR",
    "order": [{
      "id": 24,
      "portfolio_name": " Mueller Place II",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 9681,
      "name": "Austin - Travis - Texas",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 235770,
      "name": "6301 BERKMAN DR",
      "address": {
        "address_line1": "6301 BERKMAN DR",
        "address_line2": "",
        "administrative_area": "TX",
        "country_code": "US",
        "locality": "Austin",
        "postal_code": "78613",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 103,
    "name": "9109 DARTBROOK",
    "order": [{
      "id": 25,
      "portfolio_name": " The Fredd",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 7993,
      "name": "San Antonio - Bexar - Texas",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 1174347,
      "name": "9109 DARTBROOK",
      "address": {
        "address_line1": "9109 DARTBROOK",
        "address_line2": "",
        "administrative_area": "TX",
        "country_code": "US",
        "locality": "San Antonio",
        "postal_code": "78006",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 110,
    "name": "11851 BELAIR DR",
    "order": [{
      "id": 26,
      "portfolio_name": "Summer Creek Apartments",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 7993,
      "name": "San Antonio - Bexar - Texas",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 1325841,
      "name": "11851 BELAIR DR",
      "address": {
        "address_line1": "11851 BELAIR DR",
        "address_line2": "",
        "administrative_area": "TX",
        "country_code": "US",
        "locality": "San Antonio",
        "postal_code": "78006",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 117,
    "name": "1125 17th St",
    "order": [{
      "id": 27,
      "portfolio_name": "1125 17th Street",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 7262,
      "name": "Denver - Denver - Colorado",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 2163176,
      "name": "1125 17th St",
      "address": {
        "address_line1": "1125 17th St",
        "address_line2": "",
        "administrative_area": "CO",
        "country_code": "US",
        "locality": "Denver",
        "postal_code": "80014",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 124,
    "name": "2065 S Cherokee St",
    "order": [{
      "id": 28,
      "portfolio_name": "The Overland",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 7262,
      "name": "Denver - Denver - Colorado",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 2282493,
      "name": "2065 S Cherokee St",
      "address": {
        "address_line1": "2065 S Cherokee St",
        "address_line2": "",
        "administrative_area": "CO",
        "country_code": "US",
        "locality": "Denver",
        "postal_code": "80014",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 131,
    "name": "1721-1723 Ridge Ave",
    "order": [{
      "id": 29,
      "portfolio_name": "Felzenstein",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 16760,
      "name": "Philadelphia - Philadelphia - Pennsylvania",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20714398,
      "name": "1721-1723 Ridge Ave",
      "address": {
        "address_line1": "1721-1723 Ridge Ave",
        "address_line2": "",
        "administrative_area": "PA",
        "country_code": "US",
        "locality": "Philadelphia",
        "postal_code": "19130",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 136,
    "name": "1820 Peachtree Rd",
    "order": [{
      "id": 30,
      "portfolio_name": "The Brookwood Retail",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 20529,
      "name": "Atlanta - Fulton - Georgia",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20714399,
      "name": "1820 Peachtree Rd",
      "address": {
        "address_line1": "1820 Peachtree Rd",
        "address_line2": "",
        "administrative_area": "GA",
        "country_code": "US",
        "locality": "Atlanta",
        "postal_code": "30308",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 143,
    "name": "4295 Sunbeam Road",
    "order": [{
      "id": 31,
      "portfolio_name": "One at Mandarin Apartments",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 20303,
      "name": "Jacksonville - Duval - Florida",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 17887337,
      "name": "4295 Sunbeam Road",
      "address": {
        "address_line1": "4295 Sunbeam Road",
        "address_line2": "",
        "administrative_area": "FL",
        "country_code": "US",
        "locality": "Jacksonville",
        "postal_code": "32257",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 151,
    "name": " 6969 Lenoir Ave E",
    "order": [{
      "id": 32,
      "portfolio_name": " Jacksonville Southpoint",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 20303,
      "name": "Jacksonville - Duval - Florida",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20714400,
      "name": " 6969 Lenoir Ave E",
      "address": {
        "address_line1": "6969 Lenoir Avenue East",
        "address_line2": "",
        "administrative_area": "FL",
        "country_code": "US",
        "locality": "Jacksonville",
        "postal_code": "32216",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 159,
    "name": "901 Acklen Ave",
    "order": [{
      "id": 33,
      "portfolio_name": "Brentwood Baptist Church",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 20525,
      "name": "Nashville - Davidson - Tennessee",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20714401,
      "name": "901 Acklen Ave",
      "address": {
        "address_line1": "901 Acklen Ave",
        "address_line2": "",
        "administrative_area": "TN",
        "country_code": "US",
        "locality": "Nashville",
        "postal_code": "37204",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 167,
    "name": "333 Rio Vista Drive",
    "order": [{
      "id": 34,
      "portfolio_name": "Charter Village",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 20525,
      "name": "Nashville - Davidson - Tennessee",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20714402,
      "name": "333 Rio Vista Drive",
      "address": {
        "address_line1": "333 Rio Vista Drive",
        "address_line2": "",
        "administrative_area": "TN",
        "country_code": "US",
        "locality": "Nashville",
        "postal_code": "37115",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 175,
    "name": "4701 TODD RD",
    "order": [{
      "id": 35,
      "portfolio_name": "Pleasant Run",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 20528,
      "name": "Indianapolis - Marion - Indiana",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 14919351,
      "name": "4701 TODD RD",
      "address": {
        "address_line1": "4701 TODD RD",
        "address_line2": "",
        "administrative_area": "IN",
        "country_code": "US",
        "locality": "Indianapolis",
        "postal_code": "46237",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 181,
    "name": "2524 TAMARACK LN",
    "order": [{
      "id": 36,
      "portfolio_name": "Greentree Apartments",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 20528,
      "name": "Indianapolis - Marion - Indiana",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 15073542,
      "name": "2524 TAMARACK LN",
      "address": {
        "address_line1": "2524 TAMARACK LN",
        "address_line2": "",
        "administrative_area": "IN",
        "country_code": "US",
        "locality": "Indianapolis",
        "postal_code": "46227",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 187,
    "name": "775 Melrose St",
    "order": [{
      "id": 37,
      "portfolio_name": "Melrose Midtown",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 19860,
      "name": "Memphis - Shelby - Tennessee",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20714403,
      "name": "775 Melrose St",
      "address": {
        "address_line1": "775 Melrose St",
        "address_line2": "",
        "administrative_area": "TN",
        "country_code": "US",
        "locality": "Memphis",
        "postal_code": "38104",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 194,
    "name": "8475 US Hwy 64",
    "order": [{
      "id": 38,
      "portfolio_name": "Jiffy Lube",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 19860,
      "name": "Memphis - Shelby - Tennessee",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20714404,
      "name": "8475 US Hwy 64",
      "address": {
        "address_line1": "8475 US Hwy 64",
        "address_line2": "",
        "administrative_area": "TN",
        "country_code": "US",
        "locality": "Memphis",
        "postal_code": "38133",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 201,
    "name": "2301 S Valley View Blvd",
    "order": [{
      "id": 39,
      "portfolio_name": "Spanish Oaks",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 4103,
      "name": "Las Vegas - Clark - Nevada",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 20714405,
      "name": "2301 S Valley View Blvd",
      "address": {
        "address_line1": "2301 S Valley View Blvd",
        "address_line2": "",
        "administrative_area": "NV",
        "country_code": "US",
        "locality": "Las Vegas",
        "postal_code": "89102",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  }, {
    "id": 210,
    "name": "1100 Oakman Blvd",
    "order": [{
      "id": 41,
      "portfolio_name": "NSC Oakman Storage",
      "client": [{
        "id": 126,
        "name": "Test User",
        "mail": "test@test.com",
        "roles": ["authenticated", "customer"],
        "__typename": "User"
      }],
      "state": "pending",
      "__typename": "Order"
    }],
    "jurisdiction": [{
      "id": 20527,
      "name": "Detroit - Wayne - Michigan",
      "__typename": "Locality"
    }],
    "property": [{
      "id": 7842627,
      "name": "1100 Oakman Blvd",
      "address": {
        "address_line1": "1100 Oakman Blvd",
        "address_line2": "",
        "administrative_area": "MI",
        "country_code": "US",
        "locality": "Detroit",
        "postal_code": "48238",
        "__typename": "Address"
      },
      "__typename": "Property"
    }],
    "__typename": "ConformanceReportOrderItem"
  },
    {
      "id": 214,
      "name": "445 Field St",
      "order": [{
        "id": 42,
        "portfolio_name": "Island View Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20527,
        "name": "Detroit - Wayne - Michigan",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 7829296,
        "name": "445 Field St",
        "address": {
          "address_line1": "445 Field St",
          "address_line2": "",
          "administrative_area": "MI",
          "country_code": "US",
          "locality": "Detroit",
          "postal_code": "48214",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 218,
      "name": "685 SE DIVISION PL",
      "order": [{
        "id": 43,
        "portfolio_name": null,
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 3793,
        "name": "Portland - Washington - Oregon",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 8816085,
        "name": "685 SE DIVISION PL",
        "address": {
          "address_line1": "685 SE DIVISION PL",
          "address_line2": "",
          "administrative_area": "OR",
          "country_code": "US",
          "locality": "Portland",
          "postal_code": "97202",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 219,
      "name": "401 Hemphill St",
      "order": [{
        "id": 44,
        "portfolio_name": "401 Hemphill St",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 9629,
        "name": "Fort Worth - Tarrant - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714406,
        "name": "401 Hemphill St",
        "address": {
          "address_line1": "401 Hemphill St",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "Fort Worth",
          "postal_code": "76104",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 223,
      "name": "425 W PASEO REDONDO",
      "order": [{
        "id": 45,
        "portfolio_name": "425 W Paseo Redondo",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6730,
        "name": "Tucson - Pima - Arizona",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 5668411,
        "name": "425 W PASEO REDONDO",
        "address": {
          "address_line1": "425 W PASEO REDONDO",
          "address_line2": "",
          "administrative_area": "AZ",
          "country_code": "US",
          "locality": "Tucson",
          "postal_code": "85701",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 230,
      "name": "6424 S TUCSON BL",
      "order": [{
        "id": 46,
        "portfolio_name": "Burl Holdings, LLC",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6730,
        "name": "Tucson - Pima - Arizona",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 5590692,
        "name": "6424 S TUCSON BL",
        "address": {
          "address_line1": "6424 S TUCSON BL",
          "address_line2": "",
          "administrative_area": "AZ",
          "country_code": "US",
          "locality": "Tucson",
          "postal_code": "85706",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 237,
      "name": "1443 YORK AVE",
      "order": [{
        "id": 47,
        "portfolio_name": "1443 YORK AVE",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 9222,
        "name": "New York - New York - New York",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 16676104,
        "name": "1443 YORK AVE",
        "address": {
          "address_line1": "1443 YORK AVE",
          "address_line2": "",
          "administrative_area": "NY",
          "country_code": "US",
          "locality": "New York",
          "postal_code": "10021",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 245,
      "name": "9757 E COLORADO AVE",
      "order": [{
        "id": 48,
        "portfolio_name": "Park at Canyon Ridge",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 7182,
        "name": "Aurora - Arapahoe - Colorado",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 715577,
        "name": "9757 E COLORADO AVE",
        "address": {
          "address_line1": "9757 E COLORADO AVE",
          "address_line2": "",
          "administrative_area": "CO",
          "country_code": "US",
          "locality": "Aurora",
          "postal_code": "80247",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 246,
      "name": "911 Ormsby Lane",
      "order": [{
        "id": 49,
        "portfolio_name": " Lyndon Square",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20531,
        "name": "Louisville - Jefferson - Kentucky",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714407,
        "name": "911 Ormsby Lane",
        "address": {
          "address_line1": "911 Ormsby Lane",
          "address_line2": "",
          "administrative_area": "KY",
          "country_code": "US",
          "locality": "Louisville",
          "postal_code": "40241",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 253,
      "name": "181 E Santa Clara St",
      "order": [{
        "id": 50,
        "portfolio_name": "Miro Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 3480,
        "name": "San Jose - Santa Clara - California",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714408,
        "name": "181 E Santa Clara St",
        "address": {
          "address_line1": "181 E Santa Clara St",
          "address_line2": "",
          "administrative_area": "CA",
          "country_code": "US",
          "locality": "San Jose",
          "postal_code": "95113",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 261,
      "name": "10000 N Ashley Dr",
      "order": [{
        "id": 51,
        "portfolio_name": "The Times Building",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20584,
        "name": "Tampa - Hillsborough - Florida",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714409,
        "name": "10000 N Ashley Dr",
        "address": {
          "address_line1": "10000 N Ashley Dr",
          "address_line2": "",
          "administrative_area": "FL",
          "country_code": "US",
          "locality": "Tampa",
          "postal_code": "33602",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 265,
      "name": "3024 High Point Rd",
      "order": [{
        "id": 52,
        "portfolio_name": "Chiliu0027s",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 18552,
        "name": "Greensboro - Guilford - North Carolina",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714410,
        "name": "3024 High Point Rd",
        "address": {
          "address_line1": "3024 High Point Rd",
          "address_line2": "",
          "administrative_area": "NC",
          "country_code": "US",
          "locality": "Greensboro",
          "postal_code": "27403",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 270,
      "name": "9921 Horizon Overlook Dr",
      "order": [{
        "id": 53,
        "portfolio_name": "Elevate Brier Creek",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 19072,
        "name": "Raleigh  - Wake - North Carolina",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 658232,
        "name": "9921 Horizon Overlook Dr",
        "address": {
          "address_line1": "9921 HORIZON OVERLOOK DR",
          "address_line2": "",
          "administrative_area": "NC",
          "country_code": "US",
          "locality": "Raleigh ",
          "postal_code": "27617",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 275,
      "name": "4775 Summit Ridge Rd",
      "order": [{
        "id": 54,
        "portfolio_name": "4775 Summit Ridge Rd",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20533,
        "name": "Reno - Washoe - Nevada",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714412,
        "name": "4775 Summit Ridge Rd",
        "address": {
          "address_line1": "4775 Summit Ridge Rd",
          "address_line2": "",
          "administrative_area": "NV",
          "country_code": "US",
          "locality": "Reno",
          "postal_code": "89523",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 279,
      "name": "151 S Resler Dr",
      "order": [{
        "id": 55,
        "portfolio_name": "Casa Barranca Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 8666,
        "name": "El Paso - El Paso - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714413,
        "name": "151 S Resler Dr",
        "address": {
          "address_line1": "151 S Resler Dr",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "El Paso",
          "postal_code": "79912",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 283,
      "name": "1025 NW 86th St",
      "order": [{
        "id": 56,
        "portfolio_name": " Willow Run",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 4,
        "name": "Oklahoma City - Oklahoma - Oklahoma",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 15659806,
        "name": "1025 NW 86th St",
        "address": {
          "address_line1": "1025 NW 86TH ST",
          "address_line2": "",
          "administrative_area": "OK",
          "country_code": "US",
          "locality": "Oklahoma City",
          "postal_code": "73114",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 286,
      "name": "801 10th St",
      "order": [{
        "id": 57,
        "portfolio_name": "St. Maryu0027s Garden",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 3159,
        "name": "Oakland - Alameda - California",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714414,
        "name": "801 10th St",
        "address": {
          "address_line1": "801 10th St",
          "address_line2": "",
          "administrative_area": "CA",
          "country_code": "US",
          "locality": "Oakland",
          "postal_code": "94607",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 291,
      "name": "4141 Pinson Valley Pkwy",
      "order": [{
        "id": 58,
        "portfolio_name": "Village Square Landings",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20068,
        "name": "Birmingham - Jefferson - Alabama",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714415,
        "name": "4141 Pinson Valley Pkwy",
        "address": {
          "address_line1": "4141 Pinson Valley Pkwy",
          "address_line2": "",
          "administrative_area": "AL",
          "country_code": "US",
          "locality": "Birmingham",
          "postal_code": "35215",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 297,
      "name": "7439 Pan American Freeway NE",
      "order": [{
        "id": 59,
        "portfolio_name": "7439 Pan American Freeway Northeast - La Quinta",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6914,
        "name": "Albuquerque - Bernalillo - New Mexico",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 15302223,
        "name": "7439 Pan American Freeway NE",
        "address": {
          "address_line1": "7439 Pan American Freeway NE",
          "address_line2": "",
          "administrative_area": "NM",
          "country_code": "US",
          "locality": "Albuquerque",
          "postal_code": "87109",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 301,
      "name": "4000 Shader Rd",
      "order": [{
        "id": 60,
        "portfolio_name": "4000 Shader Rd",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20370,
        "name": "Orlando - Orange - Florida",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 6097398,
        "name": "4000 Shader Rd",
        "address": {
          "address_line1": "4000 SHADER RD",
          "address_line2": "",
          "administrative_area": "FL",
          "country_code": "US",
          "locality": "Orlando",
          "postal_code": "32789",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 305,
      "name": "7017 S Priest Dr",
      "order": [{
        "id": 61,
        "portfolio_name": " MetroPointe",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6670,
        "name": "Tempe - Maricopa - Arizona",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 5549723,
        "name": "7017 S Priest Dr",
        "address": {
          "address_line1": "7017 S PRIEST DR",
          "address_line2": "",
          "administrative_area": "AZ",
          "country_code": "US",
          "locality": "Tempe",
          "postal_code": "85283",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 311,
      "name": "137 Rose St",
      "order": [{
        "id": 62,
        "portfolio_name": "Rose Tower",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 19631,
        "name": "Lexington - Fayette - Kentucky",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714416,
        "name": "137 Rose St",
        "address": {
          "address_line1": "137 Rose St",
          "address_line2": "",
          "administrative_area": "KY",
          "country_code": "US",
          "locality": "Lexington",
          "postal_code": "40507",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 316,
      "name": " 1207 Mira Mar Ave",
      "order": [{
        "id": 63,
        "portfolio_name": " 1207 Mira Mar Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 3249,
        "name": "Long Beach - Los Angeles - California",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714417,
        "name": " 1207 Mira Mar Ave",
        "address": {
          "address_line1": " 1207 Mira Mar Ave",
          "address_line2": "",
          "administrative_area": "CA",
          "country_code": "US",
          "locality": "Long Beach",
          "postal_code": "90804",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 320,
      "name": "1101 Euclid Ave",
      "order": [{
        "id": 64,
        "portfolio_name": " Euclid Grand",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 19302,
        "name": "Cleveland - Cuyahoga - Ohio",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714418,
        "name": "1101 Euclid Ave",
        "address": {
          "address_line1": "1101 Euclid Ave",
          "address_line2": "",
          "administrative_area": "OH",
          "country_code": "US",
          "locality": "Cleveland",
          "postal_code": "44115",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 326,
      "name": "577 South 500 East",
      "order": [{
        "id": 65,
        "portfolio_name": "North Park Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6365,
        "name": "Salt Lake City - Salt Lake - Utah",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714419,
        "name": "577 South 500 East",
        "address": {
          "address_line1": "577 South 500 East",
          "address_line2": "",
          "administrative_area": "UT",
          "country_code": "US",
          "locality": "Salt Lake City",
          "postal_code": "84102",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 331,
      "name": "5823 Wilson Ave",
      "order": [{
        "id": 66,
        "portfolio_name": "St. Louis Hampton",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 14907,
        "name": "St. Louis - St. Louis - Missouri",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714420,
        "name": "5823 Wilson Ave",
        "address": {
          "address_line1": "5823 Wilson Ave",
          "address_line2": "",
          "administrative_area": "MO",
          "country_code": "US",
          "locality": "St. Louis",
          "postal_code": "63110",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }
  ]

  return res(
    ctx.data({
      "researchQueueItems": {
        "items": items.slice(offset, offset + limit), "total": items.length, "__typename": "ResearchQueueConnection"
      }
    })
  )
});

export const MockGetResearchClaimedQueueItems = () => graphql.query('getResearchClaimedQueueItems', (req, res, ctx) => {
  const { limit, offset } = req.variables;

  let items = [
    {
      "id": 42,
      "name": " 3111 North Tustin Avenue",
      "order": [{
        "id": 9,
        "portfolio_name": " 3111 North Tustin Avenue",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "working",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 3327,
        "name": "Orange - Orange - California",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20704937,
        "name": " 3111 North Tustin Avenue",
        "address": {
          "address_line1": "3111 N Tustin Ave",
          "address_line2": "",
          "administrative_area": "CA",
          "country_code": "US",
          "locality": "Orange",
          "postal_code": "92865",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 1,
      "name": "3000 FM 646 East",
      "order": [{
        "id": 1,
        "portfolio_name": " League City Storage",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "working",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 8833,
        "name": "League City - Galveston - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 17797374,
        "name": "3000 FM 646 East",
        "address": {
          "address_line1": "3000 FM 646 East",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "League City",
          "postal_code": "77573",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 69,
      "name": "2311 ANZIO DR",
      "order": [{
        "id": 18,
        "portfolio_name": "Wynnewood Gardens",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 8406,
        "name": "Dallas - Dallas - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 2807532,
        "name": "2311 ANZIO DR",
        "address": {
          "address_line1": "2311 ANZIO DR",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "Dallas",
          "postal_code": "75001",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 73,
      "name": "3001 KENDALE DR",
      "order": [{
        "id": 19,
        "portfolio_name": "Pecan Tree",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 8406,
        "name": "Dallas - Dallas - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 2845976,
        "name": "3001 KENDALE DR",
        "address": {
          "address_line1": "3001 KENDALE DR",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "Dallas",
          "postal_code": "75001",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 77,
      "name": "10001 N CENTRAL EXPY",
      "order": [{
        "id": 20,
        "portfolio_name": "La Quinta",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 8406,
        "name": "Dallas - Dallas - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 2713732,
        "name": "10001 N CENTRAL EXPY",
        "address": {
          "address_line1": "10001 N CENTRAL EXPY",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "Dallas",
          "postal_code": "75001",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 81,
      "name": "4410 N 99th Ave",
      "order": [{
        "id": 21,
        "portfolio_name": null,
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6665,
        "name": "Phoenix - Maricopa - Arizona",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714395,
        "name": "4410 N 99th Ave",
        "address": {
          "address_line1": "4410 N 99th Ave",
          "address_line2": "",
          "administrative_area": "AZ",
          "country_code": "US",
          "locality": "Phoenix",
          "postal_code": "85037",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 89,
      "name": "1421 Olentangy River Rd",
      "order": [{
        "id": 22,
        "portfolio_name": null,
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "working",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 19350,
        "name": "Columbus - Franklin - Ohio",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714396,
        "name": "1421 Olentangy River Rd",
        "address": {
          "address_line1": "1421 Olentangy River Rd",
          "address_line2": "",
          "administrative_area": "OH",
          "country_code": "US",
          "locality": "columbus",
          "postal_code": "43212",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 95,
      "name": "1603 E OLTORF ST",
      "order": [{
        "id": 23,
        "portfolio_name": " 1603 East Oltorf Street",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 9681,
        "name": "Austin - Travis - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 222858,
        "name": "1603 E OLTORF ST",
        "address": {
          "address_line1": "1603 E OLTORF ST",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "Austin",
          "postal_code": "78613",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 99,
      "name": "6301 BERKMAN DR",
      "order": [{
        "id": 24,
        "portfolio_name": " Mueller Place II",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 9681,
        "name": "Austin - Travis - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 235770,
        "name": "6301 BERKMAN DR",
        "address": {
          "address_line1": "6301 BERKMAN DR",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "Austin",
          "postal_code": "78613",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 103,
      "name": "9109 DARTBROOK",
      "order": [{
        "id": 25,
        "portfolio_name": " The Fredd",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 7993,
        "name": "San Antonio - Bexar - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 1174347,
        "name": "9109 DARTBROOK",
        "address": {
          "address_line1": "9109 DARTBROOK",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "San Antonio",
          "postal_code": "78006",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 110,
      "name": "11851 BELAIR DR",
      "order": [{
        "id": 26,
        "portfolio_name": "Summer Creek Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 7993,
        "name": "San Antonio - Bexar - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 1325841,
        "name": "11851 BELAIR DR",
        "address": {
          "address_line1": "11851 BELAIR DR",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "San Antonio",
          "postal_code": "78006",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 117,
      "name": "1125 17th St",
      "order": [{
        "id": 27,
        "portfolio_name": "1125 17th Street",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 7262,
        "name": "Denver - Denver - Colorado",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 2163176,
        "name": "1125 17th St",
        "address": {
          "address_line1": "1125 17th St",
          "address_line2": "",
          "administrative_area": "CO",
          "country_code": "US",
          "locality": "Denver",
          "postal_code": "80014",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 124,
      "name": "2065 S Cherokee St",
      "order": [{
        "id": 28,
        "portfolio_name": "The Overland",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 7262,
        "name": "Denver - Denver - Colorado",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 2282493,
        "name": "2065 S Cherokee St",
        "address": {
          "address_line1": "2065 S Cherokee St",
          "address_line2": "",
          "administrative_area": "CO",
          "country_code": "US",
          "locality": "Denver",
          "postal_code": "80014",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 131,
      "name": "1721-1723 Ridge Ave",
      "order": [{
        "id": 29,
        "portfolio_name": "Felzenstein",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 16760,
        "name": "Philadelphia - Philadelphia - Pennsylvania",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714398,
        "name": "1721-1723 Ridge Ave",
        "address": {
          "address_line1": "1721-1723 Ridge Ave",
          "address_line2": "",
          "administrative_area": "PA",
          "country_code": "US",
          "locality": "Philadelphia",
          "postal_code": "19130",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 136,
      "name": "1820 Peachtree Rd",
      "order": [{
        "id": 30,
        "portfolio_name": "The Brookwood Retail",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20529,
        "name": "Atlanta - Fulton - Georgia",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714399,
        "name": "1820 Peachtree Rd",
        "address": {
          "address_line1": "1820 Peachtree Rd",
          "address_line2": "",
          "administrative_area": "GA",
          "country_code": "US",
          "locality": "Atlanta",
          "postal_code": "30308",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 143,
      "name": "4295 Sunbeam Road",
      "order": [{
        "id": 31,
        "portfolio_name": "One at Mandarin Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20303,
        "name": "Jacksonville - Duval - Florida",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 17887337,
        "name": "4295 Sunbeam Road",
        "address": {
          "address_line1": "4295 Sunbeam Road",
          "address_line2": "",
          "administrative_area": "FL",
          "country_code": "US",
          "locality": "Jacksonville",
          "postal_code": "32257",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 151,
      "name": " 6969 Lenoir Ave E",
      "order": [{
        "id": 32,
        "portfolio_name": " Jacksonville Southpoint",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20303,
        "name": "Jacksonville - Duval - Florida",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714400,
        "name": " 6969 Lenoir Ave E",
        "address": {
          "address_line1": "6969 Lenoir Avenue East",
          "address_line2": "",
          "administrative_area": "FL",
          "country_code": "US",
          "locality": "Jacksonville",
          "postal_code": "32216",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 159,
      "name": "901 Acklen Ave",
      "order": [{
        "id": 33,
        "portfolio_name": "Brentwood Baptist Church",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20525,
        "name": "Nashville - Davidson - Tennessee",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714401,
        "name": "901 Acklen Ave",
        "address": {
          "address_line1": "901 Acklen Ave",
          "address_line2": "",
          "administrative_area": "TN",
          "country_code": "US",
          "locality": "Nashville",
          "postal_code": "37204",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 167,
      "name": "333 Rio Vista Drive",
      "order": [{
        "id": 34,
        "portfolio_name": "Charter Village",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20525,
        "name": "Nashville - Davidson - Tennessee",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714402,
        "name": "333 Rio Vista Drive",
        "address": {
          "address_line1": "333 Rio Vista Drive",
          "address_line2": "",
          "administrative_area": "TN",
          "country_code": "US",
          "locality": "Nashville",
          "postal_code": "37115",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 175,
      "name": "4701 TODD RD",
      "order": [{
        "id": 35,
        "portfolio_name": "Pleasant Run",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20528,
        "name": "Indianapolis - Marion - Indiana",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 14919351,
        "name": "4701 TODD RD",
        "address": {
          "address_line1": "4701 TODD RD",
          "address_line2": "",
          "administrative_area": "IN",
          "country_code": "US",
          "locality": "Indianapolis",
          "postal_code": "46237",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 181,
      "name": "2524 TAMARACK LN",
      "order": [{
        "id": 36,
        "portfolio_name": "Greentree Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20528,
        "name": "Indianapolis - Marion - Indiana",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 15073542,
        "name": "2524 TAMARACK LN",
        "address": {
          "address_line1": "2524 TAMARACK LN",
          "address_line2": "",
          "administrative_area": "IN",
          "country_code": "US",
          "locality": "Indianapolis",
          "postal_code": "46227",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 187,
      "name": "775 Melrose St",
      "order": [{
        "id": 37,
        "portfolio_name": "Melrose Midtown",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 19860,
        "name": "Memphis - Shelby - Tennessee",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714403,
        "name": "775 Melrose St",
        "address": {
          "address_line1": "775 Melrose St",
          "address_line2": "",
          "administrative_area": "TN",
          "country_code": "US",
          "locality": "Memphis",
          "postal_code": "38104",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 194,
      "name": "8475 US Hwy 64",
      "order": [{
        "id": 38,
        "portfolio_name": "Jiffy Lube",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 19860,
        "name": "Memphis - Shelby - Tennessee",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714404,
        "name": "8475 US Hwy 64",
        "address": {
          "address_line1": "8475 US Hwy 64",
          "address_line2": "",
          "administrative_area": "TN",
          "country_code": "US",
          "locality": "Memphis",
          "postal_code": "38133",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 201,
      "name": "2301 S Valley View Blvd",
      "order": [{
        "id": 39,
        "portfolio_name": "Spanish Oaks",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 4103,
        "name": "Las Vegas - Clark - Nevada",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714405,
        "name": "2301 S Valley View Blvd",
        "address": {
          "address_line1": "2301 S Valley View Blvd",
          "address_line2": "",
          "administrative_area": "NV",
          "country_code": "US",
          "locality": "Las Vegas",
          "postal_code": "89102",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 210,
      "name": "1100 Oakman Blvd",
      "order": [{
        "id": 41,
        "portfolio_name": "NSC Oakman Storage",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20527,
        "name": "Detroit - Wayne - Michigan",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 7842627,
        "name": "1100 Oakman Blvd",
        "address": {
          "address_line1": "1100 Oakman Blvd",
          "address_line2": "",
          "administrative_area": "MI",
          "country_code": "US",
          "locality": "Detroit",
          "postal_code": "48238",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    },
    {
      "id": 214,
      "name": "445 Field St",
      "order": [{
        "id": 42,
        "portfolio_name": "Island View Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20527,
        "name": "Detroit - Wayne - Michigan",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 7829296,
        "name": "445 Field St",
        "address": {
          "address_line1": "445 Field St",
          "address_line2": "",
          "administrative_area": "MI",
          "country_code": "US",
          "locality": "Detroit",
          "postal_code": "48214",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 218,
      "name": "685 SE DIVISION PL",
      "order": [{
        "id": 43,
        "portfolio_name": null,
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 3793,
        "name": "Portland - Washington - Oregon",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 8816085,
        "name": "685 SE DIVISION PL",
        "address": {
          "address_line1": "685 SE DIVISION PL",
          "address_line2": "",
          "administrative_area": "OR",
          "country_code": "US",
          "locality": "Portland",
          "postal_code": "97202",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 219,
      "name": "401 Hemphill St",
      "order": [{
        "id": 44,
        "portfolio_name": "401 Hemphill St",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 9629,
        "name": "Fort Worth - Tarrant - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714406,
        "name": "401 Hemphill St",
        "address": {
          "address_line1": "401 Hemphill St",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "Fort Worth",
          "postal_code": "76104",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 223,
      "name": "425 W PASEO REDONDO",
      "order": [{
        "id": 45,
        "portfolio_name": "425 W Paseo Redondo",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6730,
        "name": "Tucson - Pima - Arizona",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 5668411,
        "name": "425 W PASEO REDONDO",
        "address": {
          "address_line1": "425 W PASEO REDONDO",
          "address_line2": "",
          "administrative_area": "AZ",
          "country_code": "US",
          "locality": "Tucson",
          "postal_code": "85701",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 230,
      "name": "6424 S TUCSON BL",
      "order": [{
        "id": 46,
        "portfolio_name": "Burl Holdings, LLC",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6730,
        "name": "Tucson - Pima - Arizona",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 5590692,
        "name": "6424 S TUCSON BL",
        "address": {
          "address_line1": "6424 S TUCSON BL",
          "address_line2": "",
          "administrative_area": "AZ",
          "country_code": "US",
          "locality": "Tucson",
          "postal_code": "85706",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 237,
      "name": "1443 YORK AVE",
      "order": [{
        "id": 47,
        "portfolio_name": "1443 YORK AVE",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 9222,
        "name": "New York - New York - New York",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 16676104,
        "name": "1443 YORK AVE",
        "address": {
          "address_line1": "1443 YORK AVE",
          "address_line2": "",
          "administrative_area": "NY",
          "country_code": "US",
          "locality": "New York",
          "postal_code": "10021",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 245,
      "name": "9757 E COLORADO AVE",
      "order": [{
        "id": 48,
        "portfolio_name": "Park at Canyon Ridge",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 7182,
        "name": "Aurora - Arapahoe - Colorado",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 715577,
        "name": "9757 E COLORADO AVE",
        "address": {
          "address_line1": "9757 E COLORADO AVE",
          "address_line2": "",
          "administrative_area": "CO",
          "country_code": "US",
          "locality": "Aurora",
          "postal_code": "80247",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 246,
      "name": "911 Ormsby Lane",
      "order": [{
        "id": 49,
        "portfolio_name": " Lyndon Square",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20531,
        "name": "Louisville - Jefferson - Kentucky",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714407,
        "name": "911 Ormsby Lane",
        "address": {
          "address_line1": "911 Ormsby Lane",
          "address_line2": "",
          "administrative_area": "KY",
          "country_code": "US",
          "locality": "Louisville",
          "postal_code": "40241",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 253,
      "name": "181 E Santa Clara St",
      "order": [{
        "id": 50,
        "portfolio_name": "Miro Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 3480,
        "name": "San Jose - Santa Clara - California",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714408,
        "name": "181 E Santa Clara St",
        "address": {
          "address_line1": "181 E Santa Clara St",
          "address_line2": "",
          "administrative_area": "CA",
          "country_code": "US",
          "locality": "San Jose",
          "postal_code": "95113",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 261,
      "name": "10000 N Ashley Dr",
      "order": [{
        "id": 51,
        "portfolio_name": "The Times Building",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20584,
        "name": "Tampa - Hillsborough - Florida",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714409,
        "name": "10000 N Ashley Dr",
        "address": {
          "address_line1": "10000 N Ashley Dr",
          "address_line2": "",
          "administrative_area": "FL",
          "country_code": "US",
          "locality": "Tampa",
          "postal_code": "33602",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 265,
      "name": "3024 High Point Rd",
      "order": [{
        "id": 52,
        "portfolio_name": "Chiliu0027s",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 18552,
        "name": "Greensboro - Guilford - North Carolina",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714410,
        "name": "3024 High Point Rd",
        "address": {
          "address_line1": "3024 High Point Rd",
          "address_line2": "",
          "administrative_area": "NC",
          "country_code": "US",
          "locality": "Greensboro",
          "postal_code": "27403",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 270,
      "name": "9921 Horizon Overlook Dr",
      "order": [{
        "id": 53,
        "portfolio_name": "Elevate Brier Creek",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 19072,
        "name": "Raleigh  - Wake - North Carolina",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 658232,
        "name": "9921 Horizon Overlook Dr",
        "address": {
          "address_line1": "9921 HORIZON OVERLOOK DR",
          "address_line2": "",
          "administrative_area": "NC",
          "country_code": "US",
          "locality": "Raleigh ",
          "postal_code": "27617",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 275,
      "name": "4775 Summit Ridge Rd",
      "order": [{
        "id": 54,
        "portfolio_name": "4775 Summit Ridge Rd",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20533,
        "name": "Reno - Washoe - Nevada",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714412,
        "name": "4775 Summit Ridge Rd",
        "address": {
          "address_line1": "4775 Summit Ridge Rd",
          "address_line2": "",
          "administrative_area": "NV",
          "country_code": "US",
          "locality": "Reno",
          "postal_code": "89523",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 279,
      "name": "151 S Resler Dr",
      "order": [{
        "id": 55,
        "portfolio_name": "Casa Barranca Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 8666,
        "name": "El Paso - El Paso - Texas",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714413,
        "name": "151 S Resler Dr",
        "address": {
          "address_line1": "151 S Resler Dr",
          "address_line2": "",
          "administrative_area": "TX",
          "country_code": "US",
          "locality": "El Paso",
          "postal_code": "79912",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 283,
      "name": "1025 NW 86th St",
      "order": [{
        "id": 56,
        "portfolio_name": " Willow Run",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 4,
        "name": "Oklahoma City - Oklahoma - Oklahoma",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 15659806,
        "name": "1025 NW 86th St",
        "address": {
          "address_line1": "1025 NW 86TH ST",
          "address_line2": "",
          "administrative_area": "OK",
          "country_code": "US",
          "locality": "Oklahoma City",
          "postal_code": "73114",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 286,
      "name": "801 10th St",
      "order": [{
        "id": 57,
        "portfolio_name": "St. Maryu0027s Garden",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 3159,
        "name": "Oakland - Alameda - California",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714414,
        "name": "801 10th St",
        "address": {
          "address_line1": "801 10th St",
          "address_line2": "",
          "administrative_area": "CA",
          "country_code": "US",
          "locality": "Oakland",
          "postal_code": "94607",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 291,
      "name": "4141 Pinson Valley Pkwy",
      "order": [{
        "id": 58,
        "portfolio_name": "Village Square Landings",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20068,
        "name": "Birmingham - Jefferson - Alabama",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714415,
        "name": "4141 Pinson Valley Pkwy",
        "address": {
          "address_line1": "4141 Pinson Valley Pkwy",
          "address_line2": "",
          "administrative_area": "AL",
          "country_code": "US",
          "locality": "Birmingham",
          "postal_code": "35215",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 297,
      "name": "7439 Pan American Freeway NE",
      "order": [{
        "id": 59,
        "portfolio_name": "7439 Pan American Freeway Northeast - La Quinta",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6914,
        "name": "Albuquerque - Bernalillo - New Mexico",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 15302223,
        "name": "7439 Pan American Freeway NE",
        "address": {
          "address_line1": "7439 Pan American Freeway NE",
          "address_line2": "",
          "administrative_area": "NM",
          "country_code": "US",
          "locality": "Albuquerque",
          "postal_code": "87109",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 301,
      "name": "4000 Shader Rd",
      "order": [{
        "id": 60,
        "portfolio_name": "4000 Shader Rd",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 20370,
        "name": "Orlando - Orange - Florida",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 6097398,
        "name": "4000 Shader Rd",
        "address": {
          "address_line1": "4000 SHADER RD",
          "address_line2": "",
          "administrative_area": "FL",
          "country_code": "US",
          "locality": "Orlando",
          "postal_code": "32789",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 305,
      "name": "7017 S Priest Dr",
      "order": [{
        "id": 61,
        "portfolio_name": " MetroPointe",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6670,
        "name": "Tempe - Maricopa - Arizona",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 5549723,
        "name": "7017 S Priest Dr",
        "address": {
          "address_line1": "7017 S PRIEST DR",
          "address_line2": "",
          "administrative_area": "AZ",
          "country_code": "US",
          "locality": "Tempe",
          "postal_code": "85283",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 311,
      "name": "137 Rose St",
      "order": [{
        "id": 62,
        "portfolio_name": "Rose Tower",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 19631,
        "name": "Lexington - Fayette - Kentucky",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714416,
        "name": "137 Rose St",
        "address": {
          "address_line1": "137 Rose St",
          "address_line2": "",
          "administrative_area": "KY",
          "country_code": "US",
          "locality": "Lexington",
          "postal_code": "40507",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 316,
      "name": " 1207 Mira Mar Ave",
      "order": [{
        "id": 63,
        "portfolio_name": " 1207 Mira Mar Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 3249,
        "name": "Long Beach - Los Angeles - California",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714417,
        "name": " 1207 Mira Mar Ave",
        "address": {
          "address_line1": " 1207 Mira Mar Ave",
          "address_line2": "",
          "administrative_area": "CA",
          "country_code": "US",
          "locality": "Long Beach",
          "postal_code": "90804",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 320,
      "name": "1101 Euclid Ave",
      "order": [{
        "id": 64,
        "portfolio_name": " Euclid Grand",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 19302,
        "name": "Cleveland - Cuyahoga - Ohio",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714418,
        "name": "1101 Euclid Ave",
        "address": {
          "address_line1": "1101 Euclid Ave",
          "address_line2": "",
          "administrative_area": "OH",
          "country_code": "US",
          "locality": "Cleveland",
          "postal_code": "44115",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 326,
      "name": "577 South 500 East",
      "order": [{
        "id": 65,
        "portfolio_name": "North Park Apartments",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 6365,
        "name": "Salt Lake City - Salt Lake - Utah",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714419,
        "name": "577 South 500 East",
        "address": {
          "address_line1": "577 South 500 East",
          "address_line2": "",
          "administrative_area": "UT",
          "country_code": "US",
          "locality": "Salt Lake City",
          "postal_code": "84102",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }, {
      "id": 331,
      "name": "5823 Wilson Ave",
      "order": [{
        "id": 66,
        "portfolio_name": "St. Louis Hampton",
        "client": [{
          "id": 126,
          "name": "Test User",
          "mail": "test@test.com",
          "roles": ["authenticated", "customer"],
          "__typename": "User"
        }],
        "state": "pending",
        "__typename": "Order"
      }],
      "jurisdiction": [{
        "id": 14907,
        "name": "St. Louis - St. Louis - Missouri",
        "__typename": "Locality"
      }],
      "property": [{
        "id": 20714420,
        "name": "5823 Wilson Ave",
        "address": {
          "address_line1": "5823 Wilson Ave",
          "address_line2": "",
          "administrative_area": "MO",
          "country_code": "US",
          "locality": "St. Louis",
          "postal_code": "63110",
          "__typename": "Address"
        },
        "__typename": "Property"
      }],
      "__typename": "ConformanceReportOrderItem"
    }
  ]

  return res(
    ctx.data({
      "researchQueueItems": {
        "items": items.slice(offset, offset + limit), "total": items.length, "__typename": "ResearchQueueConnection"
      }
    })
  )
});

export const MockClaimResearchQueueItem = () => graphql.mutation('claimResearchQueueItem', (req, res, ctx) => {
  return res(
    ctx.data({
        "researchClaimQueueItem": {
          "claimed_item": {
            "id": 42,
            "name": " 3111 North Tustin Avenue",
            "order": [{
              "id": 9,
              "portfolio_name": " 3111 North Tustin Avenue",
              "client": [{
                "id": 126,
                "name": "Test User",
                "mail": "test@test.com",
                "roles": ["authenticated", "customer"],
                "__typename": "User"
              }],
              "state": "working",
              "__typename": "Order"
            }],
            "jurisdiction": [{
              "id": 3327,
              "name": "Orange - Orange - California",
              "__typename": "Locality"
            }],
            "property": [{
              "id": 20704937,
              "name": " 3111 North Tustin Avenue",
              "address": {
                "address_line1": "3111 N Tustin Ave",
                "address_line2": "",
                "administrative_area": "CA",
                "country_code": "US",
                "locality": "Orange",
                "postal_code": "92865",
                "__typename": "Address"
              },
              "__typename": "Property"
            }],
            "__typename": "ConformanceReportOrderItem"
          }, "errors": [], "__typename": "ResearchClaimedQueueItemResponse"
        }
    })
  )
});

export const MockGetReportItem = () => graphql.query('getReportItem', (req, res, ctx) => {
  // eslint-disable-next-line no-unused-vars
  const { id } = req.variables;

  if( id === 131) {
    return res(
      ctx.data({
            "reportItem": {
              "id": 131,
              "name": "1721-1723 Ridge Ave",
              "client_documents": [{
                "id": 1552,
                "name": "1721-1723 Ridge Ave survey.PDF",
                "document": [{
                  "filename": "1721-1723 Ridge Ave survey.PDF",
                  "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-05/1721-1723%20Ridge%20Ave%20survey.PDF",
                  "id": 81658,
                  "__typename": "File"
                }],
                "type": "document",
                "jurisdiction": [{
                  "id": 16760,
                  "name": "Philadelphia - Philadelphia - Pennsylvania",
                  "__typename": "Locality"
                }],
                "document_type": [{
                  "description": null,
                  "id": 65,
                  "name": "Survey",
                  "vid": "document_type",
                  "__typename": "TaxonomyTerm"
                }],
                "property": [{
                  "id": 20714398,
                  "name": "1721-1723 Ridge Ave",
                  "__typename": "Property"
                }],
                "__typename": "MediaDocument"
              }, {
                "id": 1553,
                "name": "1721-1723 Ridge Ave um.pdf",
                "document": [{
                  "filename": "1721-1723 Ridge Ave um.pdf",
                  "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-05/1721-1723%20Ridge%20Ave%20um.pdf",
                  "id": 81659,
                  "__typename": "File"
                }],
                "type": "document",
                "jurisdiction": [{
                  "id": 16760,
                  "name": "Philadelphia - Philadelphia - Pennsylvania",
                  "__typename": "Locality"
                }],
                "document_type": [{
                  "description": null,
                  "id": 67,
                  "name": "Unit Mix",
                  "vid": "document_type",
                  "__typename": "TaxonomyTerm"
                }],
                "property": [{
                  "id": 20714398,
                  "name": "1721-1723 Ridge Ave",
                  "__typename": "Property"
                }],
                "__typename": "MediaDocument"
              }],
              "document_order_items": [{
                "document": [],
                "document_entities": [],
                "document_order_template": [{
                  "id": 54,
                  "name": "Philadelphia Philadelphia PA ZL BV ZV FV",
                  "cost_per": "115.54",
                  "estimate_of_time": null,
                  "instructions": "",
                  "jurisdiction": [{
                    "id": 16760,
                    "name": "Philadelphia - Philadelphia - Pennsylvania",
                    "__typename": "Locality"
                  }],
                  "research_documents": [{
                    "id": "85",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }, {
                    "id": "87",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }, {
                    "id": "92",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }, {
                    "id": "86",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }],
                  "type": "online",
                  "__typename": "OnlineTemplate"
                }],
                "id": 132,
                "name": "Philadelphia Philadelphia PA ZL BV ZV FV",
                "order_date": null,
                "report_parent": [{
                  "id": 131,
                  "__typename": "ConformanceReportOrderItem"
                }],
                "quantity": 1,
                "total_price": 0,
                "type": "document_order",
                "unit_price": 0,
                "__typename": "DocumentOrderItem"
              }, {
                "document": [],
                "document_entities": [],
                "document_order_template": [{
                  "id": 55,
                  "name": "Philadelphia Philadelphia PA CO SD",
                  "cost_per": null,
                  "email_body": "email body now",
                  "email_subject": "Request for copies [property:address:address_line1]",
                  "estimate_of_time": "30",
                  "check_payable": {
                    "address_line1": "",
                    "address_line2": "",
                    "administrative_area": "",
                    "country_code": "",
                    "locality": "",
                    "postal_code": "",
                    "__typename": "Address"
                  },
                  "contact": [{
                    "id": 39,
                    "name": "Tia Platts",
                    "__typename": "JurisdictionContact"
                  }],
                  "instructions": "This is instructions",
                  "jurisdiction": [{
                    "id": 16760,
                    "name": "Philadelphia - Philadelphia - Pennsylvania",
                    "__typename": "Locality"
                  }],
                  "research_documents": [{
                    "id": "89",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }, {
                    "id": "117",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }, {
                    "id": "118",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }, {
                    "id": "91",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }, {
                    "id": "94",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }, {
                    "id": "95",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }],
                  "type": "email",
                  "__typename": "EmailTemplate"
                }],
                "id": 133,
                "name": "Philadelphia Philadelphia PA CO SD",
                "order_date": null,
                "report_parent": [{
                  "id": 131,
                  "__typename": "ConformanceReportOrderItem"
                }],
                "quantity": 1,
                "total_price": 0,
                "type": "document_order",
                "unit_price": 0,
                "__typename": "DocumentOrderItem"
              }, {
                "document": [],
                "document_entities": [],
                "document_order_template": [{
                  "id": 56,
                  "name": "Philadelphia Philadelphia PA CN",
                  "cost_per": "12.00",
                  "email_body": "Email Body",
                  "email_subject": "Request for copies [property:address:address_line1]",
                  "estimate_of_time": "30",
                  "check_payable": {
                    "address_line1": "",
                    "address_line2": "",
                    "administrative_area": "",
                    "country_code": "",
                    "locality": "",
                    "postal_code": "",
                    "__typename": "Address"
                  },
                  "contact": [{
                    "id": 38,
                    "name": "Tom Marro",
                    "__typename": "JurisdictionContact"
                  }],
                  "instructions": "Instruction String",
                  "jurisdiction": [{
                    "id": 16760,
                    "name": "Philadelphia - Philadelphia - Pennsylvania",
                    "__typename": "Locality"
                  }],
                  "research_documents": [{
                    "id": "90",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }],
                  "type": "email",
                  "__typename": "EmailTemplate"
                }],
                "id": 134,
                "name": "Philadelphia Philadelphia PA CN",
                "order_date": null,
                "report_parent": [{
                  "id": 131,
                  "__typename": "ConformanceReportOrderItem"
                }],
                "quantity": 1,
                "total_price": 0,
                "type": "document_order",
                "unit_price": 0,
                "__typename": "DocumentOrderItem"
              }, {
                "document": [],
                "document_entities": [],
                "document_order_template": [{
                  "id": 947,
                  "name": "Philadelphia Philadelphia PA BL",
                  "cost_per": null,
                  "estimate_of_time": null,
                  "instructions": "this are the structions",
                  "jurisdiction": [{
                    "id": 16760,
                    "name": "Philadelphia - Philadelphia - Pennsylvania",
                    "__typename": "Locality"
                  }],
                  "research_documents": [{
                    "id": "88",
                    "name": null,
                    "__typename": "ResearchDocumentType"
                  }],
                  "type": "online",
                  "__typename": "OnlineTemplate"
                }],
                "id": 135,
                "name": "Philadelphia Philadelphia PA BL",
                "order_date": null,
                "report_parent": [{
                  "id": 131,
                  "__typename": "ConformanceReportOrderItem"
                }],
                "quantity": 1,
                "total_price": 0,
                "type": "document_order",
                "unit_price": 0,
                "__typename": "DocumentOrderItem"
              }],
              "jurisdiction": [{
                "id": 16760,
                "name": "Philadelphia - Philadelphia - Pennsylvania",
                "__typename": "Locality"
              }],
              "order": [{
                "id": 29,
                "state": "pending",
                "client": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "billing_information": [{
                    "id": 17,
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "Suite 200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserBillingInformation"
                  }],
                  "contact_information": [{
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 18,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserContactInformation"
                  }],
                  "prepared_for": [{
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "Suite 200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 12,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "3555 NW 58th Street",
                      "address_line2": "Suite 400",
                      "administrative_area": "OK",
                      "country_code": "US",
                      "locality": "Oklahoma City",
                      "postal_code": "73112",
                      "__typename": "Address"
                    },
                    "id": 15,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 20,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 22,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 24,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 26,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 28,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 30,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 32,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 34,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 36,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 38,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 40,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 42,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 44,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 46,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 48,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 50,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 52,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 54,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 56,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 58,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 60,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 62,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 64,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 66,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 68,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 70,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 72,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 74,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 76,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 78,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 80,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 82,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 84,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 86,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 88,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 90,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 92,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 94,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 96,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 98,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 100,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 102,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 104,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 106,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 108,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 110,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 112,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 114,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 116,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 118,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 120,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 122,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 124,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 126,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 128,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 130,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 132,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 134,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 136,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 138,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 140,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 142,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 144,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 146,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 148,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 150,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 152,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 154,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 156,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 158,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 160,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 162,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 164,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 166,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 168,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 170,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 172,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 174,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 176,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 178,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 180,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 182,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 184,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 189,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 194,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 196,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 198,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 203,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 205,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 207,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 209,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 211,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 213,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 215,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 217,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 219,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 223,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 225,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 227,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 229,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 231,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 237,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 243,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 245,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 247,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 249,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 251,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 253,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 259,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 261,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 263,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 265,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 267,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 269,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 271,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 273,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 275,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 277,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 279,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 281,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 283,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 285,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 287,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 289,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 291,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 293,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 295,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 299,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 301,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 303,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 305,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 307,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 309,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 311,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 313,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 315,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 317,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 319,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 321,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 323,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 325,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 327,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 329,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 331,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 333,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 335,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 337,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 339,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 341,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 343,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 345,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 347,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 349,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 351,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 353,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 355,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 357,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 359,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 361,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 363,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 365,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 367,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 369,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 371,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 373,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 375,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 377,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 379,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 381,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 383,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 385,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 387,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 389,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 391,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 393,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 395,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 397,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 399,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 401,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 403,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 405,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 407,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 409,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 411,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 413,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 415,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 417,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 419,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 421,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 423,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 425,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 427,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 429,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 431,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 433,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 435,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 437,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 439,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 441,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 443,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 445,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 451,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 453,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 455,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 457,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 459,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 461,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 463,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 469,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 471,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 473,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 475,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 477,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 487,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 489,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 491,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 493,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 495,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 497,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 501,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 503,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 505,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 507,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 509,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 511,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 513,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 519,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 521,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 523,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 525,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 527,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 533,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }, {
                    "address": {
                      "address_line1": "2509 Scripture Street",
                      "address_line2": "200",
                      "administrative_area": "TX",
                      "country_code": "US",
                      "locality": "Denton",
                      "postal_code": "76201",
                      "__typename": "Address"
                    },
                    "id": 535,
                    "user": [{
                      "id": 126,
                      "name": "Test User",
                      "mail": "test@test.com",
                      "__typename": "User"
                    }],
                    "__typename": "UserPreparedFor"
                  }],
                  "__typename": "User"
                }],
                "prepared_for": [{
                  "id": 58,
                  "address": {
                    "address_line1": "2509 Scripture Street",
                    "address_line2": "200",
                    "administrative_area": "TX",
                    "country_code": "US",
                    "locality": "Denton",
                    "postal_code": "76201",
                    "__typename": "Address"
                  },
                  "__typename": "UserPreparedFor"
                }],
                "adjustments": [],
                "portfolio_name": "Felzenstein",
                "__typename": "Order"
              }],
              "order_documents": [{
                "id": "zoning_letter",
                "name": "Zoning Letter,",
                "__typename": "OrderDocument"
              }, {
                "id": "building_violations",
                "name": "Building Violations,",
                "__typename": "OrderDocument"
              }, {
                "id": "fire_code_violations",
                "name": "Fire Code Violations,",
                "__typename": "OrderDocument"
              }, {
                "id": "zoning_violations",
                "name": "Zoning Code Violations,",
                "__typename": "OrderDocument"
              }, {
                "id": "certificate_of_occupancy",
                "name": "Certificate of Occupancy,",
                "__typename": "OrderDocument"
              }, {
                "id": "condemnation",
                "name": "Condemnation,",
                "__typename": "OrderDocument"
              }, {
                "id": "business_license",
                "name": "Business License,",
                "__typename": "OrderDocument"
              }, {
                "id": "historical_landmark",
                "name": "Historical/Landmark",
                "__typename": "OrderDocument"
              }],
              "property": [{
                "id": 20714398,
                "name": "1721-1723 Ridge Ave",
                "address": {
                  "address_line1": "1721-1723 Ridge Ave",
                  "address_line2": "",
                  "administrative_area": "PA",
                  "country_code": "US",
                  "locality": "Philadelphia",
                  "postal_code": "19130",
                  "__typename": "Address"
                },
                "jurisdiction": [{
                  "id": 16760,
                  "name": "Philadelphia - Philadelphia - Pennsylvania",
                  "__typename": "Locality"
                }],
                "notes": null,
                "parcel_map": [],
                "google_map": [],
                "parcel_tax_id": null,
                "use": [{
                  "id": 64942,
                  "name": "Multi-Family",
                  "__typename": "Use"
                }],
                "zone": [{
                  "id": 7876,
                  "name": "Neighborhood Commercial Mixed-Use District-2.5",
                  "__typename": "Zone"
                }],
                "property_type": [{
                  "id": "existing",
                  "name": "Existing",
                  "__typename": "JurisdictionReference"
                }],
                "zoning_map": [],
                "abutting_zoning": [{
                  "id": 48162,
                  "name": null,
                  "__typename": "AbuttingZoning"
                }],
                "__typename": "Property"
              }],
              "status": "pending",
              "quantity": 1,
              "total_price": 800,
              "type": "conformance_report",
              "unit_price": 800,
              "__typename": "ConformanceReportOrderItem"
            }
      })
    )
  }

  if(id === 42) {
    return res(
      ctx.data({
        "reportItem": {
          "id": 42,
          "name": " 3111 North Tustin Avenue",
          "client_documents": [{
            "id": 1520,
            "name": "3111 North Tustin Avenue RR.pdf",
            "document": [{
              "filename": "3111 North Tustin Avenue RR.pdf",
              "filepath": "Thing",
              "id": 81448,
              "__typename": "File"
            }],
            "type": "document",
            "jurisdiction": [{
              "id": 3327,
              "name": "Orange - Orange - California",
              "__typename": "Locality"
            }],
            "document_type": [{
              "description": null,
              "id": 66,
              "name": "Tenant List",
              "vid": "document_type",
              "__typename": "TaxonomyTerm"
            }],
            "property": [{
              "id": 20704937,
              "name": " 3111 North Tustin Avenue",
              "__typename": "Property"
            }],
            "__typename": "MediaDocument"
          }, {
            "id": 1521,
            "name": "3111 North Tustin Avenue.pdf",
            "document": [{
              "filename": "3111 North Tustin Avenue.pdf",
              "filepath": "Thing",
              "id": 81449,
              "__typename": "File"
            }],
            "type": "document",
            "jurisdiction": [{
              "id": 3327,
              "name": "Orange - Orange - California",
              "__typename": "Locality"
            }],
            "document_type": [{
              "description": null,
              "id": 65,
              "name": "Survey",
              "vid": "document_type",
              "__typename": "TaxonomyTerm"
            }],
            "property": [{
              "id": 20704937,
              "name": " 3111 North Tustin Avenue",
              "__typename": "Property"
            }],
            "__typename": "MediaDocument"
          }],
          "document_order_items": [{
            "document": [{
              "id": 1702,
              "name": "3111 North Tustin Avenue var.pdf",
              "property": [{
                "id": 20704937,
                "name": " 3111 North Tustin Avenue",
                "__typename": "Property"
              }],
              "jurisdiction": [{
                "id": 3327,
                "name": "Orange - Orange - California",
                "__typename": "Locality"
              }],
              "document": [{
                "filename": "3111 North Tustin Avenue var.pdf",
                "filepath": "Thing",
                "id": 82926,
                "__typename": "File"
              }],
              "document_type": [{
                "description": null,
                "id": 95,
                "name": "Variance",
                "vid": "document_type",
                "__typename": "TaxonomyTerm"
              }],
              "__typename": "MediaDocument"
            }, {
              "id": 1701,
              "name": "3111 North Tustin Avenue cn.pdf",
              "property": [{
                "id": 20704937,
                "name": " 3111 North Tustin Avenue",
                "__typename": "Property"
              }],
              "jurisdiction": [{
                "id": 3327,
                "name": "Orange - Orange - California",
                "__typename": "Locality"
              }],
              "document": [{
                "filename": "3111 North Tustin Avenue cn.pdf",
                "filepath": "thing",
                "id": 82924,
                "__typename": "File"
              }],
              "document_type": [{
                "description": null,
                "id": 90,
                "name": "Condemnation",
                "vid": "document_type",
                "__typename": "TaxonomyTerm"
              }],
              "__typename": "MediaDocument"
            }, {
              "id": 1700,
              "name": "3111 North Tustin Avenue fv.pdf",
              "property": [{
                "id": 20704937,
                "name": " 3111 North Tustin Avenue",
                "__typename": "Property"
              }],
              "jurisdiction": [{
                "id": 3327,
                "name": "Orange - Orange - California",
                "__typename": "Locality"
              }],
              "document": [{
                "filename": "3111 North Tustin Avenue fv.pdf",
                "filepath": "Thing",
                "id": 82923,
                "__typename": "File"
              }],
              "document_type": [{
                "description": null,
                "id": 92,
                "name": "Fire Code Violation",
                "vid": "document_type",
                "__typename": "TaxonomyTerm"
              }],
              "__typename": "MediaDocument"
            }, {
              "id": 1699,
              "name": "3111 North Tustin Avenue BV ZV.pdf",
              "property": [{
                "id": 20704937,
                "name": " 3111 North Tustin Avenue",
                "__typename": "Property"
              }],
              "jurisdiction": [{
                "id": 3327,
                "name": "Orange - Orange - California",
                "__typename": "Locality"
              }],
              "document": [{
                "filename": "3111 North Tustin Avenue BV ZV.pdf",
                "filepath": "Thing",
                "id": 82921,
                "__typename": "File"
              }],
              "document_type": [{
                "description": null,
                "id": 86,
                "name": "Zoning Code Violation",
                "vid": "document_type",
                "__typename": "TaxonomyTerm"
              }],
              "__typename": "MediaDocument"
            }, {
              "id": 1698,
              "name": "3111 North Tustin Avenue BV ZV.pdf",
              "property": [{
                "id": 20704937,
                "name": " 3111 North Tustin Avenue",
                "__typename": "Property"
              }],
              "jurisdiction": [{
                "id": 3327,
                "name": "Orange - Orange - California",
                "__typename": "Locality"
              }],
              "document": [{
                "filename": "3111 North Tustin Avenue BV ZV.pdf",
                "filepath": "Thing",
                "id": 82920,
                "__typename": "File"
              }],
              "document_type": [{
                "description": null,
                "id": 87,
                "name": "Building Code Violation",
                "vid": "document_type",
                "__typename": "TaxonomyTerm"
              }],
              "__typename": "MediaDocument"
            }, {
              "id": 1697,
              "name": "3111 North Tustin AvenueCO.pdf",
              "property": [{
                "id": 20704937,
                "name": " 3111 North Tustin Avenue",
                "__typename": "Property"
              }],
              "jurisdiction": [{
                "id": 3327,
                "name": "Orange - Orange - California",
                "__typename": "Locality"
              }],
              "document": [{
                "filename": "3111 North Tustin AvenueCO.pdf",
                "filepath": "thing",
                "id": 82919,
                "__typename": "File"
              }],
              "document_type": [{
                "description": null,
                "id": 89,
                "name": "Certificate of Occupancy",
                "vid": "document_type",
                "__typename": "TaxonomyTerm"
              }],
              "__typename": "MediaDocument"
            }],
            "document_entities": {
              "95": [["50", "Property|20704937|Variance", "variance"]],
              "90": [["49", "Property|20704937|Condemnation", "condemnation"]],
              "92": [["48", "Property|20704937|FireCodeViolation", "fire_code_violation"]],
              "86": [["47", "Property|20704937|ZoningCodeViolation", "zoning_code_violation"]],
              "87": [["46", "Property|20704937|BuildingCodeViolation", "building_code_violation"]],
              "89": [["45", "Property|20704937|Condemnation", "certificate_of_occupancy"]]
            },
            "document_order_template": [{
              "id": 1606,
              "name": "Orange Orange CA CO BV ZV FV CN SD",
              "cost_per": null,
              "estimate_of_time": "10",
              "instructions": "thing",
              "jurisdiction": [{
                "id": 3327,
                "name": "Orange - Orange - California",
                "__typename": "Locality"
              }],
              "research_documents": [{
                "id": "87",
                "name": null,
                "__typename": "ResearchDocumentType"
              }, {
                "id": "92",
                "name": null,
                "__typename": "ResearchDocumentType"
              }, {
                "id": "86",
                "name": null,
                "__typename": "ResearchDocumentType"
              }, {
                "id": "89",
                "name": null,
                "__typename": "ResearchDocumentType"
              }, {
                "id": "90",
                "name": null,
                "__typename": "ResearchDocumentType"
              }, {
                "id": "117",
                "name": null,
                "__typename": "ResearchDocumentType"
              }, {
                "id": "118",
                "name": null,
                "__typename": "ResearchDocumentType"
              }, {
                "id": "91",
                "name": null,
                "__typename": "ResearchDocumentType"
              }, {
                "id": "94",
                "name": null,
                "__typename": "ResearchDocumentType"
              }, {
                "id": "95",
                "name": null,
                "__typename": "ResearchDocumentType"
              }],
              "type": "online",
              "__typename": "OnlineTemplate"
            }],
            "id": 43,
            "name": "Orange Orange CA CO BV ZV FV CN SD",
            "order_date": null,
            "report_parent": [{
              "id": 42,
              "__typename": "ConformanceReportOrderItem"
            }],
            "quantity": 1,
            "total_price": 0,
            "type": "document_order",
            "unit_price": 0,
            "__typename": "DocumentOrderItem"
          }, {
            "document": [{
              "id": 1696,
              "name": "3111 North Tustin Avenue ZL.pdf",
              "property": [{
                "id": 20704937,
                "name": " 3111 North Tustin Avenue",
                "__typename": "Property"
              }],
              "jurisdiction": [{
                "id": 3327,
                "name": "Orange - Orange - California",
                "__typename": "Locality"
              }],
              "document": [{
                "filename": "3111 North Tustin Avenue ZL.pdf",
                "filepath": "thing",
                "id": 82917,
                "__typename": "File"
              }],
              "document_type": [{
                "description": null,
                "id": 85,
                "name": "Zoning Letter",
                "vid": "document_type",
                "__typename": "TaxonomyTerm"
              }],
              "__typename": "MediaDocument"
            }],
            "document_entities": {"85": [["44", "Property|20704937|ZoningLetter", "zoning_letter"]]},
            "document_order_template": [{
              "id": 1622,
              "name": "Orange Orange CA ZL",
              "cost_per": "316.00",
              "email_body": "thing",
              "email_subject": "Request for a Zoning Verification Letter [property:address:address_line1]",
              "estimate_of_time": "15",
              "check_payable": {
                "address_line1": "",
                "address_line2": "",
                "administrative_area": "",
                "country_code": "",
                "locality": "",
                "postal_code": "",
                "__typename": "Address"
              },
              "contact": [{
                "id": 355,
                "name": "Tiffany Chhan",
                "__typename": "JurisdictionContact"
              }],
              "instructions": "thing",
              "jurisdiction": [{
                "id": 3327,
                "name": "Orange - Orange - California",
                "__typename": "Locality"
              }],
              "research_documents": [{
                "id": "85",
                "name": null,
                "__typename": "ResearchDocumentType"
              }],
              "type": "email",
              "__typename": "EmailTemplate"
            }],
            "id": 44,
            "name": "Orange Orange CA ZL",
            "order_date": null,
            "report_parent": [{
              "id": 42,
              "__typename": "ConformanceReportOrderItem"
            }],
            "quantity": 1,
            "total_price": 0,
            "type": "document_order",
            "unit_price": 0,
            "__typename": "DocumentOrderItem"
          }],
          "jurisdiction": [{
            "id": 3327,
            "name": "Orange - Orange - California",
            "__typename": "Locality"
          }],
          "order": [{
            "id": 9,
            "state": "working",
            "client": [{
              "id": 126,
              "name": "Test User",
              "mail": "test@test.com",
              "billing_information": [{
                "id": 17,
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "Suite 200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserBillingInformation"
              }],
              "contact_information": [{
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 18,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserContactInformation"
              }],
              "prepared_for": [{
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "Suite 200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 12,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "3555 NW 58th Street",
                  "address_line2": "Suite 400",
                  "administrative_area": "OK",
                  "country_code": "US",
                  "locality": "Oklahoma City",
                  "postal_code": "73112",
                  "__typename": "Address"
                },
                "id": 15,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 20,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 22,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 24,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 26,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 28,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 30,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 32,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 34,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 36,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 38,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 40,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 42,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 44,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 46,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 48,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 50,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 52,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 54,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 56,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 58,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 60,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 62,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 64,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 66,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 68,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 70,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 72,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 74,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 76,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 78,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 80,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 82,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 84,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 86,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 88,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 90,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 92,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 94,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 96,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 98,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 100,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 102,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 104,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 106,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 108,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 110,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 112,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 114,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 116,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 118,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 120,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 122,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 124,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 126,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 128,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 130,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 132,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 134,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 136,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 138,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 140,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 142,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 144,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 146,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 148,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 150,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 152,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 154,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 156,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 158,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 160,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 162,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 164,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 166,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 168,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 170,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 172,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 174,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 176,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 178,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 180,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 182,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 184,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 189,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 194,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 196,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 198,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 203,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 205,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 207,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 209,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 211,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 213,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 215,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 217,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 219,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 223,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 225,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 227,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 229,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 231,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 237,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 243,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 245,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 247,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 249,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 251,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 253,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 259,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 261,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 263,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 265,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 267,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 269,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 271,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 273,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 275,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 277,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 279,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 281,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 283,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 285,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 287,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 289,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 291,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 293,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 295,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 299,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 301,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 303,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 305,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 307,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 309,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 311,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 313,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 315,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 317,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 319,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 321,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 323,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 325,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 327,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 329,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 331,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 333,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 335,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 337,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 339,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 341,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 343,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 345,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 347,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 349,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 351,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 353,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 355,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 357,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 359,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 361,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 363,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 365,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 367,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 369,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 371,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 373,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 375,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 377,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 379,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 381,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 383,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 385,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 387,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 389,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 391,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 393,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 395,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 397,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 399,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 401,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 403,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 405,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 407,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 409,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 411,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 413,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 415,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 417,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 419,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 421,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 423,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 425,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 427,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 429,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 431,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 433,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 435,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 437,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 439,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 441,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 443,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 445,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 451,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 453,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 455,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 457,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 459,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 461,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 463,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 469,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 471,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 473,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 475,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 477,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 487,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 489,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 491,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 493,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 495,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 497,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 501,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 503,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 505,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 507,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 509,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 511,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 513,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 519,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 521,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 523,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 525,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 527,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 533,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }, {
                "address": {
                  "address_line1": "2509 Scripture Street",
                  "address_line2": "200",
                  "administrative_area": "TX",
                  "country_code": "US",
                  "locality": "Denton",
                  "postal_code": "76201",
                  "__typename": "Address"
                },
                "id": 535,
                "user": [{
                  "id": 126,
                  "name": "Test User",
                  "mail": "test@test.com",
                  "__typename": "User"
                }],
                "__typename": "UserPreparedFor"
              }],
              "__typename": "User"
            }],
            "prepared_for": [{
              "id": 20,
              "address": {
                "address_line1": "2509 Scripture Street",
                "address_line2": "200",
                "administrative_area": "TX",
                "country_code": "US",
                "locality": "Denton",
                "postal_code": "76201",
                "__typename": "Address"
              },
              "__typename": "UserPreparedFor"
            }],
            "adjustments": [],
            "portfolio_name": " 3111 North Tustin Avenue",
            "__typename": "Order"
          }],
          "order_documents": [{
            "id": "zoning_letter",
            "name": "Zoning Letter,",
            "__typename": "OrderDocument"
          }, {
            "id": "building_violations",
            "name": "Building Violations,",
            "__typename": "OrderDocument"
          }, {
            "id": "fire_code_violations",
            "name": "Fire Code Violations,",
            "__typename": "OrderDocument"
          }, {
            "id": "zoning_violations",
            "name": "Zoning Code Violations,",
            "__typename": "OrderDocument"
          }, {
            "id": "certificate_of_occupancy",
            "name": "Certificate of Occupancy,",
            "__typename": "OrderDocument"
          }, {
            "id": "condemnation",
            "name": "Condemnation,",
            "__typename": "OrderDocument"
          }, {
            "id": "business_license",
            "name": "Business License,",
            "__typename": "OrderDocument"
          }, {
            "id": "historical_landmark",
            "name": "Historical/Landmark,",
            "__typename": "OrderDocument"
          }],
          "property": [{
            "id": 20704937,
            "name": " 3111 North Tustin Avenue",
            "address": {
              "address_line1": "3111 N Tustin Ave",
              "address_line2": "",
              "administrative_area": "CA",
              "country_code": "US",
              "locality": "Orange",
              "postal_code": "92865",
              "__typename": "Address"
            },
            "jurisdiction": [{
              "id": 3327,
              "name": "Orange - Orange - California",
              "__typename": "Locality"
            }],
            "notes": "u003Cpu003EProperty is on Border of City of Anaheimu003C/pu003E",
            "parcel_map": [],
            "google_map": [],
            "parcel_tax_id": "360-291-04",
            "use": [],
            "zone": [{
              "id": 25891,
              "name": "Limited Business",
              "__typename": "Zone"
            }],
            "property_type": [{
              "id": "",
              "name": "",
              "__typename": "JurisdictionReference"
            }],
            "zoning_map": [],
            "abutting_zoning": [{
              "id": 48156,
              "name": "East",
              "__typename": "AbuttingZoning"
            }],
            "__typename": "Property"
          }],
          "status": "pending",
          "quantity": 1,
          "total_price": 800,
          "type": "conformance_report",
          "unit_price": 800,
          "__typename": "ConformanceReportOrderItem"
        }
    }));
  }
});

export const MockGetProperty = () => graphql.query('getProperty', (req, res, ctx) => {
  // eslint-disable-next-line no-unused-vars

  return res(ctx.data(
    {"property": {
        "abutting_zoning": [{
          "id": 48156,
          "name": "East",
          "zoning": [{
            "id": 25870,
            "name": "Single Family Residential",
            "designation": "R1-7",
            "__typename": "Zone"
          }],
          "__typename": "AbuttingZoning"
        }],
        "address": {
          "additional_name": "",
          "address_line1": "3111 N Tustin Ave",
          "address_line2": "",
          "administrative_area": "CA",
          "country_code": "US",
          "dependent_locality": "",
          "family_name": "",
          "given_name": "",
          "langcode": "",
          "locality": "Orange",
          "organization": "",
          "postal_code": "92865",
          "sorting_code": "",
          "__typename": "Address"
        },
        "id": 20704937,
        "name": " 3111 North Tustin Avenue",
        "jurisdiction": [{
          "id": 3327,
          "name": "Orange - Orange - California",
          "__typename": "Locality"
        }],
        "google_map": [],
        "notes": "u003Cpu003EProperty is on Border of City of Anaheimu003C/pu003E",
        "parcel_map": [],
        "parcel_tax_id": "360-291-04",
        "use": [],
        "zone": [{
          "id": 25891,
          "name": "Limited Business",
          "designation": "C1",
          "__typename": "Zone"
        }],
        "zoning_map": [],
        "__typename": "Property"
    }
  }))
});


export const MockGetZonesForJurisdiction = () => graphql.query('getZonesForJurisdiction', (req, res, ctx) => {
  // eslint-disable-next-line no-unused-vars

  return res(ctx.data({
      "zones": {
        "count": 1,
        "items": [{
          "id": 25870,
          "name": "Single Family Residential",
          "type": "zone",
          "category": [{
            "id": 6340,
            "name": "Residential",
            "__typename": "ZoneList"
          }],
          "description": " A single-family residential district with a minimum lot area of seven thousand (7,000) square feet.",
          "designation": "R1-7",
          "code_file": [],
          "code_date": "1969-12-31",
          "__typename": "Zone"
        }, {
          "id": 25871,
          "name": "Double Family Residential",
          "type": "zone",
          "category": [{
            "id": 6340,
            "name": "Residential",
            "__typename": "ZoneList"
          }],
          "description": " A dobule-family residential district with a minimum lot area of seven thousand (7,000) square feet.",
          "designation": "R2-7",
          "code_file": [],
          "code_date": "1969-12-31",
          "__typename": "Zone"
        }],
        "__typename": "ZoneConnection"
      }
  }))
});

export const MockGetMediaImages = () => graphql.query('getMediaImages', (req, res, ctx) => {
  // eslint-disable-next-line no-unused-vars

  return res(ctx.data({
      "mediaImages": {
        "items": [],
        "total": 0,
        "__typename": "MediaImageConnection"
      }
  }));
});

export const MockGetJurisdiction = () => graphql.query('getJurisdiction', (req, res, ctx) => {
  // eslint-disable-next-line no-unused-vars
  const { id } = req.variables;

  if(id) {
    return res(ctx.data({
        "jurisdiction": {
          "id": 3327,
          "name": "Orange - Orange - California",
          "type": "locality",
          "subdivision": [{
            "id": 2945,
            "name": "Orange - California",
            "__typename": "Subdivision"
          }],
          "locality_type": [{
            "id": 30,
            "name": "City",
            "__typename": "TaxonomyTerm"
          }],
          "code_definition": {
            "url": "https://library.municode.com/ca/orange/codes/municipal_code?nodeId=TIT17ZO",
            "link_text": "City of Orange",
            "__typename": "Link"
          },
          "gis_map": {
            "link_text": "",
            "url": "https://cityoforange.maps.arcgis.com/apps/webappviewer/index.html?id=004fdfb3dadc4968a49888dcb3b896b7",
            "__typename": "Link"
          },
          "parcel_map": {
            "link_text": "",
            "url": "https://cityoforange.maps.arcgis.com/apps/webappviewer/index.html?id=ffa98284466c4cf6b684af1d1a166675",
            "__typename": "Link"
          },
          "__typename": "Locality"
        }
    }));
  }
});



export const MockGetMediaDocuments = () => graphql.query('getMediaDocuments', (req, res, ctx) => {
  // eslint-disable-next-line no-unused-vars
  const { id } = req.variables;

  if(id) {
    return res(ctx.data({
        "mediaDocuments": {
          "items": [],
          "total": 0,
          "__typename": "MediaDocumentConnection"
        }
    }));
  } else {
    return res(ctx.data({
      "mediaDocuments": {
        "items": [],
        "total": 0,
        "__typename": "MediaDocumentConnection"
      }
    }));
  }
});

export const MockGetBvViolations = () => graphql.query('getBvViolations', (req, res, ctx) => {
  return res(ctx.data({
        "bvViolations": [{
          "id": "N/A",
          "name": "N/A",
          "__typename": "BVViolation"
        }, {
          "id": "Yes",
          "name": "Yes, there are currently outstanding Building Code Violations on file",
          "__typename": "BVViolation"
        }, {
          "id": "No",
          "name": "No, there are currently no outstanding Building Code Violations on file",
          "__typename": "BVViolation"
        }, {"id": "Other", "name": "Other", "__typename": "BVViolation"}]
    }));
});

export const MockGetDocumentTypes = () => graphql.query('getDocumentTypes', (req, res, ctx) => {
  return res(ctx.data({
      "documentTypes": [{
        "id": 87,
        "name": "Building Code Violation",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 88,
        "name": "Business License",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 89,
        "name": "Certificate of Occupancy",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 90,
        "name": "Condemnation",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 91,
        "name": "Conditional Use Permit",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 119,
        "name": "Conformance Report",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 120,
        "name": "Fannie Mae Third-Party Report Standards",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 92,
        "name": "Fire Code Violation",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 93,
        "name": "Historical / Landmark",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 118,
        "name": "PUD",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 117,
        "name": "Site Plan",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 94,
        "name": "Special Use Permit",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 65,
        "name": "Survey",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 66,
        "name": "Tenant List",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 67,
        "name": "Unit Mix",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 95,
        "name": "Variance",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 86,
        "name": "Zoning Code Violation",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }, {
        "id": 85,
        "name": "Zoning Letter",
        "vid": "document_type",
        "description": null,
        "__typename": "TaxonomyTerm"
      }]
  }));
});

export const MockResidentialOrders = () => graphql.query('residentialOrders', (req, res, ctx) => {
  return res(ctx.data({
    "documentTypes": [{
      "id": 87,
      "name": "Building Code Violation",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 88,
      "name": "Business License",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 89,
      "name": "Certificate of Occupancy",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 90,
      "name": "Condemnation",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 91,
      "name": "Conditional Use Permit",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 119,
      "name": "Conformance Report",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 120,
      "name": "Fannie Mae Third-Party Report Standards",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 92,
      "name": "Fire Code Violation",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 93,
      "name": "Historical / Landmark",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 118,
      "name": "PUD",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 117,
      "name": "Site Plan",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 94,
      "name": "Special Use Permit",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 65,
      "name": "Survey",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 66,
      "name": "Tenant List",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 67,
      "name": "Unit Mix",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 95,
      "name": "Variance",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 86,
      "name": "Zoning Code Violation",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }, {
      "id": 85,
      "name": "Zoning Letter",
      "vid": "document_type",
      "description": null,
      "__typename": "TaxonomyTerm"
    }]
  }));
});

export const MockGetTenants = () => graphql.query('getTenants', (req, res, ctx) => {
  return res(ctx.data({"tenants":[]}));
});

export const MockGetUsesForJurisdiction = () => graphql.query('getUsesForJurisdiction', (req, res, ctx) => {
  return res(ctx.data({
      "uses": {
        "count": 195,
        "items": [{
          "name": "Single-Family",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64940,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3505,
            "name": "Residential",
            "__typename": "UseList"
          }],
          "parking": [{
            "id": 100607,
            "min_max": "min",
            "name": "1/unit",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": null,
            "description": null,
            "spaces": "1.00",
            "use": [{
              "id": 64940,
              "name": "Single-Family",
              "__typename": "Use"
            }],
            "zone": [],
            "__typename": "ParkingLink"
          }],
          "__typename": "Use"
        }, {
          "name": "Two-Family",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64941,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3505,
            "name": "Residential",
            "__typename": "UseList"
          }],
          "parking": [{
            "id": 100636,
            "min_max": "min",
            "name": "1/unit",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": null,
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64941, "name": "Two-Family", "__typename": "Use"}],
            "zone": [],
            "__typename": "ParkingLink"
          }, {
            "id": 100639,
            "min_max": "min",
            "name": "1/2 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "2.00",
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64941, "name": "Two-Family", "__typename": "Use"}],
            "zone": [{
              "id": 13248,
              "name": "Residential Multi-Family Districts",
              "designation": "RM-2",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100640,
            "min_max": "min",
            "name": "1/2 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "2.00",
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64941, "name": "Two-Family", "__typename": "Use"}],
            "zone": [{
              "id": 13249,
              "name": "Residential Multi-Family Districts",
              "designation": "RM-3",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100641,
            "min_max": "min",
            "name": "1/2 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "2.00",
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64941, "name": "Two-Family", "__typename": "Use"}],
            "zone": [{
              "id": 13250,
              "name": "Residential Multi-Family Districts",
              "designation": "RM-4",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100643,
            "min_max": "min",
            "name": "1/2 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "2.00",
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64941, "name": "Two-Family", "__typename": "Use"}],
            "zone": [{
              "id": 13251,
              "name": "Residential Mixed-Use Districts",
              "designation": "RMX-2",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100645,
            "min_max": "min",
            "name": "1/2 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "2.00",
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64941, "name": "Two-Family", "__typename": "Use"}],
            "zone": [{
              "id": 13252,
              "name": "Residential Mixed-Use Districts ",
              "designation": "RMX-3",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }],
          "__typename": "Use"
        }, {
          "name": "Multi-Family",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64942,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3505,
            "name": "Residential",
            "__typename": "UseList"
          }],
          "parking": [{
            "id": 18536,
            "min_max": "min",
            "name": "1/Unit",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": null,
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [],
            "__typename": "ParkingLink"
          }, {
            "id": 18547,
            "min_max": "min",
            "name": "3/10 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "10.00",
            "description": null,
            "spaces": "3.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 13248,
              "name": "Residential Multi-Family Districts",
              "designation": "RM-2",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 18571,
            "min_max": "min",
            "name": "3/10 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "10.00",
            "description": null,
            "spaces": "3.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 13249,
              "name": "Residential Multi-Family Districts",
              "designation": "RM-3",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100651,
            "min_max": "min",
            "name": "3/10 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "10.00",
            "description": null,
            "spaces": "3.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 13250,
              "name": "Residential Multi-Family Districts",
              "designation": "RM-4",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100653,
            "min_max": "min",
            "name": "3/10 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "10.00",
            "description": null,
            "spaces": "3.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 13251,
              "name": "Residential Mixed-Use Districts",
              "designation": "RMX-2",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100654,
            "min_max": "min",
            "name": "3/10 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "10.00",
            "description": null,
            "spaces": "3.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 13252,
              "name": "Residential Mixed-Use Districts ",
              "designation": "RMX-3",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100657,
            "min_max": "min",
            "name": "3/10 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "10.00",
            "description": null,
            "spaces": "3.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 7877,
              "name": "Community Commercial Mixed-Use District ",
              "designation": "CMX-3",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100659,
            "min_max": "min",
            "name": "3/10 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "10.00",
            "description": null,
            "spaces": "3.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 7878,
              "name": "Center City Commercial Mixed-Use District",
              "designation": "CMX-4",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100661,
            "min_max": "min",
            "name": "3/10 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "10.00",
            "description": null,
            "spaces": "3.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 7879,
              "name": "Center City Core Commercial Mixed-Use District ",
              "designation": "CMX-5",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100662,
            "min_max": "min",
            "name": "3/10 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "10.00",
            "description": null,
            "spaces": "3.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 7882,
              "name": "Industrial Residential Mixed-Use District ",
              "designation": "IRMX ",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100663,
            "min_max": "min",
            "name": "1/2 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "2.00",
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 7883,
              "name": "Industrial Commercial Mixed-Use District ",
              "designation": "ICMX ",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100664,
            "min_max": "min",
            "name": "1/2 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "2.00",
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 7884,
              "name": "Light Industrial District ",
              "designation": "I-1 ",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100665,
            "min_max": "min",
            "name": "1/2 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "2.00",
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 7885,
              "name": "Medium Industrial District ",
              "designation": "I-2",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 100740,
            "min_max": "min",
            "name": "1/2 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "2.00",
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 7886,
              "name": "Heavy Industrial District ",
              "designation": "I-3 ",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }, {
            "id": 102033,
            "min_max": "min",
            "name": "1/2 units",
            "parking": [{
              "id": 1,
              "name": "per dwelling unit",
              "__typename": "Parking"
            }],
            "secondary_variable": "2.00",
            "description": null,
            "spaces": "1.00",
            "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
            "zone": [{
              "id": 7887,
              "name": "Port Industrial District ",
              "designation": "I-P ",
              "__typename": "Zone"
            }],
            "__typename": "ParkingLink"
          }],
          "__typename": "Use"
        }, {
          "name": "Group Living",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64943,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3505,
            "name": "Residential",
            "__typename": "UseList"
          }],
          "parking": [{
            "id": 18551,
            "min_max": "min",
            "name": "1/10 permanent beds",
            "parking": [{"id": 7, "name": "per beds", "__typename": "Parking"}],
            "secondary_variable": "10.00",
            "description": "string",
            "spaces": "1.00",
            "use": [{"id": 64943, "name": "Group Living", "__typename": "Use"}],
            "zone": [],
            "__typename": "ParkingLink"
          }],
          "__typename": "Use"
        }, {
          "name": "Personal Care Home",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64944,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3505,
            "name": "Residential",
            "__typename": "UseList"
          }],
          "parking": [{
            "id": 18655,
            "min_max": "min",
            "name": "1/10 permanent beds",
            "parking": [{"id": 7, "name": "per beds", "__typename": "Parking"}],
            "secondary_variable": "10.00",
            "description": "string",
            "spaces": "1.00",
            "use": [{
              "id": 64944,
              "name": "Personal Care Home",
              "__typename": "Use"
            }],
            "zone": [],
            "__typename": "ParkingLink"
          }],
          "__typename": "Use"
        }, {
          "name": "Single-Room Residence",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64945,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3505,
            "name": "Residential",
            "__typename": "UseList"
          }],
          "parking": [{
            "id": 18554,
            "min_max": "min",
            "name": "1/20 Sleeping Units",
            "parking": [{"id": 7, "name": "per beds", "__typename": "Parking"}],
            "secondary_variable": "20.00",
            "description": "string",
            "spaces": "1.00",
            "use": [{
              "id": 64945,
              "name": "Single-Room Residence",
              "__typename": "Use"
            }],
            "zone": [],
            "__typename": "ParkingLink"
          }, {
            "id": 18556,
            "min_max": "min",
            "name": "1 space",
            "parking": [{"id": 20, "name": "Fixed", "__typename": "Parking"}],
            "secondary_variable": null,
            "description": null,
            "spaces": "1.00",
            "use": [{
              "id": 64945,
              "name": "Single-Room Residence",
              "__typename": "Use"
            }],
            "zone": [],
            "__typename": "ParkingLink"
          }, {
            "id": 18558,
            "min_max": "min",
            "name": "2 spaces",
            "parking": [{"id": 20, "name": "Fixed", "__typename": "Parking"}],
            "secondary_variable": null,
            "description": null,
            "spaces": "2.00",
            "use": [{
              "id": 64945,
              "name": "Single-Room Residence",
              "__typename": "Use"
            }],
            "zone": [],
            "__typename": "ParkingLink"
          }],
          "__typename": "Use"
        }, {
          "name": "Passive Recreation",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64946,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3506,
            "name": "Parks and Open Space",
            "__typename": "UseList"
          }],
          "parking": [],
          "__typename": "Use"
        }, {
          "name": "Active Recreation",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64947,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3506,
            "name": "Parks and Open Space",
            "__typename": "UseList"
          }],
          "parking": [],
          "__typename": "Use"
        }, {
          "name": "Adult Care",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64948,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3507,
            "name": "Public, Civic, and Institutional",
            "__typename": "UseList"
          }],
          "parking": [{
            "id": 18936,
            "min_max": "min",
            "name": "1/1000 sf",
            "parking": [{"id": 4, "name": "GFA", "__typename": "Parking"}],
            "secondary_variable": "1000.00",
            "description": "string",
            "spaces": "1.00",
            "use": [{"id": 64948, "name": "Adult Care", "__typename": "Use"}],
            "zone": [],
            "__typename": "ParkingLink"
          }],
          "__typename": "Use"
        }, {
          "name": "Family Child Care",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64949,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3507,
            "name": "Public, Civic, and Institutional",
            "__typename": "UseList"
          }],
          "parking": [],
          "__typename": "Use"
        }, {
          "name": "Group Child Care",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64950,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3507,
            "name": "Public, Civic, and Institutional",
            "__typename": "UseList"
          }],
          "parking": [{
            "id": 19153,
            "min_max": "min",
            "name": "1/1000 sf",
            "parking": [{"id": 4, "name": "GFA", "__typename": "Parking"}],
            "secondary_variable": "1000.00",
            "description": "string",
            "spaces": "1.00",
            "use": [{
              "id": 64950,
              "name": "Group Child Care",
              "__typename": "Use"
            }],
            "zone": [],
            "__typename": "ParkingLink"
          }],
          "__typename": "Use"
        }, {
          "name": "Child Care Center",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64951,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3507,
            "name": "Public, Civic, and Institutional",
            "__typename": "UseList"
          }],
          "parking": [{
            "id": 19102,
            "min_max": "min",
            "name": "1/1000 sf",
            "parking": [{"id": 4, "name": "GFA", "__typename": "Parking"}],
            "secondary_variable": "1000.00",
            "description": null,
            "spaces": "1.00",
            "use": [{
              "id": 64951,
              "name": "Child Care Center",
              "__typename": "Use"
            }],
            "zone": [],
            "__typename": "ParkingLink"
          }],
          "__typename": "Use"
        }, {
          "name": "Community Center",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64952,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3507,
            "name": "Public, Civic, and Institutional",
            "__typename": "UseList"
          }],
          "parking": [],
          "__typename": "Use"
        }, {
          "name": "Educational Facilities",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64953,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3507,
            "name": "Public, Civic, and Institutional",
            "__typename": "UseList"
          }],
          "parking": [],
          "__typename": "Use"
        }, {
          "name": "Fraternal Organization",
          "weight": 0,
          "certificate_required": true,
          "code_location": "Table 14-602-1",
          "id": 64954,
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "category": [{
            "id": 3507,
            "name": "Public, Civic, and Institutional",
            "__typename": "UseList"
          }],
          "parking": [],
          "__typename": "Use"
        }],
        "__typename": "UseConnection"
      }
    }));
});

export const MockGetResearchDocuments = () => graphql.query('getResearchDocuments', (req, res, ctx) => {
  return res(ctx.data({
      "researchDocuments": {
        "items": [{
          "id": 1,
          "name": "Property|221705|BuildingCodeViolation",
          "notes": null,
          "bv_violations": [{
            "id": "Yes",
            "name": "Yes, there are currently outstanding Building Code Violations on file",
            "__typename": "BVViolation"
          }],
          "bv_violations_other": null,
          "letter_date": "2022-04-04",
          "document": [{
            "document": [{
              "filename": "72275 BV ZV FV_19.pdf",
              "filepath": "string",
              "id": 72414,
              "__typename": "File"
            }],
            "id": 1354,
            "name": "72275 BV ZV FV_19.pdf",
            "document_type": [{
              "id": 87,
              "name": "Building Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 221705,
            "name": "12601 TECH RIDGE BLVD",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "building_code_violation",
          "__typename": "BuildingCodeViolation"
        }, {
          "id": 2,
          "name": "Property|17797374|ZoningCodeViolation",
          "letter_date": "2022-02-28",
          "notes": "string",
          "document": [{
            "document": [{
              "filename": "3000 FM 646 BV ZV FV.pdf",
              "filepath": "string",
              "id": 81725,
              "__typename": "File"
            }],
            "id": 1577,
            "name": "3000 FM 646 BV ZV FV.pdf",
            "document_type": [{
              "id": 86,
              "name": "Zoning Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 17797374,
            "name": "3000 FM 646 East",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_code_violation",
          "zv_violations": [{
            "id": "No, there are currently no outstanding Zoning Code Violations on file.",
            "name": "No, there are currently no outstanding Zoning Code Violations on file.",
            "__typename": "ZVViolation"
          }],
          "zv_violations_other": null,
          "__typename": "ZoningCodeViolation"
        }, {
          "id": 3,
          "name": "Property|17797374|BuildingCodeViolation",
          "notes": null,
          "bv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Building Code Violations on file",
            "__typename": "BVViolation"
          }],
          "bv_violations_other": null,
          "letter_date": "2022-02-28",
          "document": [{
            "document": [{
              "filename": "3000 FM 646 BV ZV FV.pdf",
              "filepath": "string",
              "id": 81726,
              "__typename": "File"
            }],
            "id": 1578,
            "name": "3000 FM 646 BV ZV FV.pdf",
            "document_type": [{
              "id": 87,
              "name": "Building Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 17797374,
            "name": "3000 FM 646 East",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "building_code_violation",
          "__typename": "BuildingCodeViolation"
        }, {
          "id": 4,
          "name": "Property|17797374|FireCodeViolation",
          "fv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Fire Code Violations on file.",
            "__typename": "FVViolation"
          }],
          "fv_violations_other": null,
          "document": [{
            "document": [{
              "filename": "3000 FM 646 BV ZV FV.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/3000%20FM%20646%20BV%20ZV%20FV_1.pdf",
              "id": 81727,
              "__typename": "File"
            }],
            "id": 1579,
            "name": "3000 FM 646 BV ZV FV.pdf",
            "document_type": [{
              "id": 92,
              "name": "Fire Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-02-28",
          "notes": null,
          "permit_number": null,
          "property": [{
            "id": 17797374,
            "name": "3000 FM 646 East",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "fire_code_violation",
          "__typename": "FireCodeViolation"
        }, {
          "id": 5,
          "name": "Property|17797374|Condemnation",
          "cn_plans": [{
            "id": "No, there are currently no known Condemnation Plans at this time.",
            "name": "No, there are currently no known Condemnation Plans at this time.",
            "__typename": "CNPlan"
          }],
          "cn_plans_other": null,
          "document": [{
            "document": [{
              "filename": "3000 FM 646 CN.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/3000%20FM%20646%20CN.pdf",
              "id": 81728,
              "__typename": "File"
            }],
            "id": 1580,
            "name": "3000 FM 646 CN.pdf",
            "document_type": [{
              "id": 90,
              "name": "Condemnation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-02-28",
          "notes": null,
          "property": [{
            "id": 17797374,
            "name": "3000 FM 646 East",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "condemnation",
          "__typename": "Condemnation"
        }, {
          "id": 6,
          "name": "Property|2807532|Condemnation",
          "cn_plans": [{
            "id": "No, there are currently no known Condemnation Plans at this time.",
            "name": "No, there are currently no known Condemnation Plans at this time.",
            "__typename": "CNPlan"
          }],
          "cn_plans_other": null,
          "document": [{
            "document": [{
              "filename": "Wynnewood Gardens cn.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-05/Wynnewood%20Gardens%20cn_0.pdf",
              "id": 81637,
              "__typename": "File"
            }],
            "id": 1536,
            "name": "Wynnewood Gardens cn.pdf",
            "document_type": [{
              "id": 90,
              "name": "Condemnation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2021-12-13",
          "notes": null,
          "property": [{
            "id": 2807532,
            "name": "2311 ANZIO DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "condemnation",
          "__typename": "Condemnation"
        }, {
          "id": 7,
          "name": "Property|2807532|FireCodeViolation",
          "fv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Fire Code Violations on file.",
            "__typename": "FVViolation"
          }],
          "fv_violations_other": null,
          "document": [{
            "document": [{
              "filename": "Wynnewood Gardens fv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Wynnewood%20Gardens%20fv.pdf",
              "id": 81795,
              "__typename": "File"
            }],
            "id": 1584,
            "name": "Wynnewood Gardens fv.pdf",
            "document_type": [{
              "id": 92,
              "name": "Fire Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2021-12-13",
          "notes": null,
          "permit_number": null,
          "property": [{
            "id": 2807532,
            "name": "2311 ANZIO DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "fire_code_violation",
          "__typename": "FireCodeViolation"
        }, {
          "id": 8,
          "name": "Property|2807532|BuildingCodeViolation",
          "notes": null,
          "bv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Building Code Violations on file",
            "__typename": "BVViolation"
          }],
          "bv_violations_other": null,
          "letter_date": "2021-12-13",
          "document": [{
            "document": [{
              "filename": "Wynnewood Gardens bv zv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-05/Wynnewood%20Gardens%20bv%20zv.pdf",
              "id": 81635,
              "__typename": "File"
            }],
            "id": 1534,
            "name": "Wynnewood Gardens bv zv.pdf",
            "document_type": [{
              "id": 87,
              "name": "Building Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 2807532,
            "name": "2311 ANZIO DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "building_code_violation",
          "__typename": "BuildingCodeViolation"
        }, {
          "id": 9,
          "name": "Property|2807532|ZoningCodeViolation",
          "letter_date": "2021-12-13",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "Wynnewood Gardens zv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Wynnewood%20Gardens%20zv.pdf",
              "id": 81796,
              "__typename": "File"
            }],
            "id": 1585,
            "name": "Wynnewood Gardens zv.pdf",
            "document_type": [{
              "id": 86,
              "name": "Zoning Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 2807532,
            "name": "2311 ANZIO DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_code_violation",
          "zv_violations": [{
            "id": "No, there are currently no outstanding Zoning Code Violations on file.",
            "name": "No, there are currently no outstanding Zoning Code Violations on file.",
            "__typename": "ZVViolation"
          }],
          "zv_violations_other": null,
          "__typename": "ZoningCodeViolation"
        }, {
          "id": 10,
          "name": "Property|2807532|ZoningLetter",
          "letter_date": "2021-12-28",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "Wynnewood Gardens zl.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-05/Wynnewood%20Gardens%20zl.pdf",
              "id": 81638,
              "__typename": "File"
            }],
            "id": 1537,
            "name": "Wynnewood Gardens zl.pdf",
            "document_type": [{
              "id": 85,
              "name": "Zoning Letter",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 2807532,
            "name": "2311 ANZIO DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_letter",
          "__typename": "ZoningLetter"
        }, {
          "id": 11,
          "name": "Property|2845976|BuildingCodeViolation",
          "notes": null,
          "bv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Building Code Violations on file",
            "__typename": "BVViolation"
          }],
          "bv_violations_other": null,
          "letter_date": "2022-01-27",
          "document": [{
            "document": [{
              "filename": "Pecan Tree bv zv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Pecan%20Tree%20bv%20zv.pdf",
              "id": 81797,
              "__typename": "File"
            }],
            "id": 1586,
            "name": "Pecan Tree bv zv.pdf",
            "document_type": [{
              "id": 87,
              "name": "Building Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 2845976,
            "name": "3001 KENDALE DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "building_code_violation",
          "__typename": "BuildingCodeViolation"
        }, {
          "id": 12,
          "name": "Property|2845976|ZoningCodeViolation",
          "letter_date": "2022-01-27",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "Pecan Tree bv zv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Pecan%20Tree%20bv%20zv_0.pdf",
              "id": 81798,
              "__typename": "File"
            }],
            "id": 1587,
            "name": "Pecan Tree bv zv.pdf",
            "document_type": [{
              "id": 86,
              "name": "Zoning Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 2845976,
            "name": "3001 KENDALE DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_code_violation",
          "zv_violations": [{
            "id": "No, there are currently no outstanding Zoning Code Violations on file.",
            "name": "No, there are currently no outstanding Zoning Code Violations on file.",
            "__typename": "ZVViolation"
          }],
          "zv_violations_other": null,
          "__typename": "ZoningCodeViolation"
        }, {
          "id": 13,
          "name": "Property|2845976|Condemnation",
          "cn_plans": [{
            "id": "No, there are currently no known Condemnation Plans at this time.",
            "name": "No, there are currently no known Condemnation Plans at this time.",
            "__typename": "CNPlan"
          }],
          "cn_plans_other": null,
          "document": [{
            "document": [{
              "filename": "Pecan Tree fv cn.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Pecan%20Tree%20fv%20cn_0.pdf",
              "id": 81800,
              "__typename": "File"
            }],
            "id": 1589,
            "name": "Pecan Tree fv cn.pdf",
            "document_type": [{
              "id": 90,
              "name": "Condemnation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-02-18",
          "notes": null,
          "property": [{
            "id": 2845976,
            "name": "3001 KENDALE DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "condemnation",
          "__typename": "Condemnation"
        }, {
          "id": 14,
          "name": "Property|2845976|FireCodeViolation",
          "fv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Fire Code Violations on file.",
            "__typename": "FVViolation"
          }],
          "fv_violations_other": null,
          "document": [{
            "document": [{
              "filename": "Pecan Tree fv cn.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Pecan%20Tree%20fv%20cn.pdf",
              "id": 81799,
              "__typename": "File"
            }],
            "id": 1588,
            "name": "Pecan Tree fv cn.pdf",
            "document_type": [{
              "id": 92,
              "name": "Fire Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-02-18",
          "notes": null,
          "permit_number": null,
          "property": [{
            "id": 2845976,
            "name": "3001 KENDALE DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "fire_code_violation",
          "__typename": "FireCodeViolation"
        }, {
          "id": 15,
          "name": "Property|2845976|Condemnation",
          "building_number": null,
          "co_date": "2005-03-22",
          "co_number": "0503221120",
          "document": [{
            "document": [{
              "filename": "Pecan Tree co.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Pecan%20Tree%20co.pdf",
              "id": 81801,
              "__typename": "File"
            }],
            "id": 1590,
            "name": "Pecan Tree co.pdf",
            "document_type": [{
              "id": 89,
              "name": "Certificate of Occupancy",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "notes": null,
          "parking_required": null,
          "property": [{
            "id": 2845976,
            "name": "3001 KENDALE DR",
            "__typename": "Property"
          }],
          "provider": [],
          "square_footage": null,
          "tenant": [],
          "type": "certificate_of_occupancy",
          "use": [{"id": 5586, "name": "Multifamily", "__typename": "Use"}],
          "__typename": "CertificateOfOccupancy"
        }, {
          "id": 16,
          "name": "Property|2713732|Condemnation",
          "building_number": null,
          "co_date": "2001-11-09",
          "co_number": "0111096002",
          "document": [{
            "document": [{
              "filename": "10001 North Central Expressway CO.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/10001%20North%20Central%20Expressway%20CO.pdf",
              "id": 81802,
              "__typename": "File"
            }],
            "id": 1591,
            "name": "10001 North Central Expressway CO.pdf",
            "document_type": [{
              "id": 89,
              "name": "Certificate of Occupancy",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "notes": null,
          "parking_required": null,
          "property": [{
            "id": 2713732,
            "name": "10001 N CENTRAL EXPY",
            "__typename": "Property"
          }],
          "provider": [],
          "square_footage": null,
          "tenant": [],
          "type": "certificate_of_occupancy",
          "use": [{"id": 49509, "name": "Hotel or Motel", "__typename": "Use"}],
          "__typename": "CertificateOfOccupancy"
        }, {
          "id": 17,
          "name": "Property|2713732|ZoningLetter",
          "letter_date": "2022-03-05",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "10001 North Central Expressway ZL.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/10001%20North%20Central%20Expressway%20ZL_0.pdf",
              "id": 81804,
              "__typename": "File"
            }],
            "id": 1592,
            "name": "10001 North Central Expressway ZL.pdf",
            "document_type": [{
              "id": 85,
              "name": "Zoning Letter",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 2713732,
            "name": "10001 N CENTRAL EXPY",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_letter",
          "__typename": "ZoningLetter"
        }, {
          "id": 18,
          "name": "Property|20714395|Condemnation",
          "cn_plans": [{
            "id": "No, there are currently no known Condemnation Plans at this time.",
            "name": "No, there are currently no known Condemnation Plans at this time.",
            "__typename": "CNPlan"
          }],
          "cn_plans_other": null,
          "document": [{
            "document": [{
              "filename": "Tamarron Apartments cn.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Tamarron%20Apartments%20cn.pdf",
              "id": 81805,
              "__typename": "File"
            }],
            "id": 1593,
            "name": "Tamarron Apartments cn.pdf",
            "document_type": [{
              "id": 90,
              "name": "Condemnation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-01-25",
          "notes": null,
          "property": [{
            "id": 20714395,
            "name": "4410 N 99th Ave",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "condemnation",
          "__typename": "Condemnation"
        }, {
          "id": 19,
          "name": "Property|20714395|FireCodeViolation",
          "fv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Fire Code Violations on file.",
            "__typename": "FVViolation"
          }],
          "fv_violations_other": null,
          "document": [{
            "document": [{
              "filename": "Tamarron Apartments FV.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Tamarron%20Apartments%20FV.pdf",
              "id": 81806,
              "__typename": "File"
            }],
            "id": 1594,
            "name": "Tamarron Apartments FV.pdf",
            "document_type": [{
              "id": 92,
              "name": "Fire Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-02-17",
          "notes": null,
          "permit_number": null,
          "property": [{
            "id": 20714395,
            "name": "4410 N 99th Ave",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "fire_code_violation",
          "__typename": "FireCodeViolation"
        }, {
          "id": 20,
          "name": "Property|20714395|ZoningCodeViolation",
          "letter_date": "2022-01-25",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "Tamarron Apartments ZV.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Tamarron%20Apartments%20ZV.pdf",
              "id": 81807,
              "__typename": "File"
            }],
            "id": 1595,
            "name": "Tamarron Apartments ZV.pdf",
            "document_type": [{
              "id": 86,
              "name": "Zoning Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 20714395,
            "name": "4410 N 99th Ave",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_code_violation",
          "zv_violations": [{
            "id": "No, there are currently no outstanding Zoning Code Violations on file.",
            "name": "No, there are currently no outstanding Zoning Code Violations on file.",
            "__typename": "ZVViolation"
          }],
          "zv_violations_other": null,
          "__typename": "ZoningCodeViolation"
        }, {
          "id": 21,
          "name": "Property|20714395|BuildingCodeViolation",
          "notes": null,
          "bv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Building Code Violations on file",
            "__typename": "BVViolation"
          }],
          "bv_violations_other": null,
          "letter_date": "2022-02-16",
          "document": [{
            "document": [{
              "filename": "Tamarron Apartments bv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/Tamarron%20Apartments%20bv.pdf",
              "id": 81808,
              "__typename": "File"
            }],
            "id": 1596,
            "name": "Tamarron Apartments bv.pdf",
            "document_type": [{
              "id": 87,
              "name": "Building Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 20714395,
            "name": "4410 N 99th Ave",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "building_code_violation",
          "__typename": "BuildingCodeViolation"
        }, {
          "id": 22,
          "name": "Property|20714396|ZoningLetter",
          "letter_date": "2022-03-07",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "1421 Olentangy ZL.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/1421%20Olentangy%20ZL.pdf",
              "id": 81894,
              "__typename": "File"
            }],
            "id": 1609,
            "name": "1421 Olentangy ZL.pdf",
            "document_type": [{
              "id": 85,
              "name": "Zoning Letter",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 20714396,
            "name": "1421 Olentangy River Rd",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_letter",
          "__typename": "ZoningLetter"
        }, {
          "id": 23,
          "name": "Property|20714396|Condemnation",
          "building_number": null,
          "co_date": "2011-08-18",
          "co_number": "CBLD1009983",
          "document": [{
            "document": [{
              "filename": "1421 Olentangy CO.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/1421%20Olentangy%20CO.pdf",
              "id": 81895,
              "__typename": "File"
            }],
            "id": 1610,
            "name": "1421 Olentangy CO.pdf",
            "document_type": [{
              "id": 89,
              "name": "Certificate of Occupancy",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "notes": null,
          "parking_required": null,
          "property": [{
            "id": 20714396,
            "name": "1421 Olentangy River Rd",
            "__typename": "Property"
          }],
          "provider": [],
          "square_footage": 79166,
          "tenant": [{
            "id": 1524,
            "name": "Springhill Suites Columbus OSU",
            "__typename": "Tenant"
          }],
          "type": "certificate_of_occupancy",
          "use": [{"id": 56735, "name": "Hotel or Motel", "__typename": "Use"}],
          "__typename": "CertificateOfOccupancy"
        }, {
          "id": 24,
          "name": "Property|20714396|BuildingCodeViolation",
          "notes": null,
          "bv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Building Code Violations on file",
            "__typename": "BVViolation"
          }],
          "bv_violations_other": null,
          "letter_date": "2022-03-07",
          "document": [{
            "document": [{
              "filename": "1421 Olentangy bv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/1421%20Olentangy%20bv.pdf",
              "id": 81897,
              "__typename": "File"
            }],
            "id": 1612,
            "name": "1421 Olentangy bv.pdf",
            "document_type": [{
              "id": 87,
              "name": "Building Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 20714396,
            "name": "1421 Olentangy River Rd",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "building_code_violation",
          "__typename": "BuildingCodeViolation"
        }, {
          "id": 25,
          "name": "Property|20714396|ZoningCodeViolation",
          "letter_date": "2022-03-07",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "1421 Olentangy zv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/1421%20Olentangy%20zv.pdf",
              "id": 81896,
              "__typename": "File"
            }],
            "id": 1611,
            "name": "1421 Olentangy zv.pdf",
            "document_type": [{
              "id": 86,
              "name": "Zoning Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 20714396,
            "name": "1421 Olentangy River Rd",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_code_violation",
          "zv_violations": [{
            "id": "No, there are currently no outstanding Zoning Code Violations on file.",
            "name": "No, there are currently no outstanding Zoning Code Violations on file.",
            "__typename": "ZVViolation"
          }],
          "zv_violations_other": null,
          "__typename": "ZoningCodeViolation"
        }, {
          "id": 26,
          "name": "Property|20714396|FireCodeViolation",
          "fv_violations": [{
            "id": "Yes",
            "name": "Yes, there are currently outstanding Fire Code Violations on file.",
            "__typename": "FVViolation"
          }],
          "fv_violations_other": null,
          "document": [{
            "document": [{
              "filename": "1421 Olentangy fv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/1421%20Olentangy%20fv.pdf",
              "id": 81898,
              "__typename": "File"
            }],
            "id": 1613,
            "name": "1421 Olentangy fv.pdf",
            "document_type": [{
              "id": 92,
              "name": "Fire Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-03-11",
          "notes": "u003Cpu003ENeed Backflow reportu003C/pu003E",
          "permit_number": null,
          "property": [{
            "id": 20714396,
            "name": "1421 Olentangy River Rd",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "fire_code_violation",
          "__typename": "FireCodeViolation"
        }, {
          "id": 27,
          "name": "Property|20714396|Condemnation",
          "cn_plans": [{
            "id": "No, there are currently no known Condemnation Plans at this time.",
            "name": "No, there are currently no known Condemnation Plans at this time.",
            "__typename": "CNPlan"
          }],
          "cn_plans_other": null,
          "document": [{
            "document": [{
              "filename": "1421 Olentangy cn.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/1421%20Olentangy%20cn.pdf",
              "id": 81899,
              "__typename": "File"
            }],
            "id": 1614,
            "name": "1421 Olentangy cn.pdf",
            "document_type": [{
              "id": 90,
              "name": "Condemnation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-04-08",
          "notes": null,
          "property": [{
            "id": 20714396,
            "name": "1421 Olentangy River Rd",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "condemnation",
          "__typename": "Condemnation"
        }, {
          "id": 28,
          "name": "Property|235770|Condemnation",
          "building_number": null,
          "co_date": "2006-10-19",
          "co_number": "2006-018594 BP",
          "document": [{
            "document": [{
              "filename": "6301 BERKMAN co.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/6301%20BERKMAN%20co.pdf",
              "id": 81921,
              "__typename": "File"
            }],
            "id": 1615,
            "name": "6301 BERKMAN co.pdf",
            "document_type": [{
              "id": 89,
              "name": "Certificate of Occupancy",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "notes": null,
          "parking_required": null,
          "property": [{
            "id": 235770,
            "name": "6301 BERKMAN DR",
            "__typename": "Property"
          }],
          "provider": [],
          "square_footage": null,
          "tenant": [],
          "type": "certificate_of_occupancy",
          "use": [],
          "__typename": "CertificateOfOccupancy"
        }, {
          "id": 29,
          "name": "Property|235770|BuildingCodeViolation",
          "notes": null,
          "bv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Building Code Violations on file",
            "__typename": "BVViolation"
          }],
          "bv_violations_other": null,
          "letter_date": "2022-04-07",
          "document": [{
            "document": [{
              "filename": "6301 BERKMAN bv zv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/6301%20BERKMAN%20bv%20zv.pdf",
              "id": 81922,
              "__typename": "File"
            }],
            "id": 1616,
            "name": "6301 BERKMAN bv zv.pdf",
            "document_type": [{
              "id": 87,
              "name": "Building Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 235770,
            "name": "6301 BERKMAN DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "building_code_violation",
          "__typename": "BuildingCodeViolation"
        }, {
          "id": 30,
          "name": "Property|235770|ZoningCodeViolation",
          "letter_date": "2022-04-07",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "6301 BERKMAN bv zv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/6301%20BERKMAN%20bv%20zv_1.pdf",
              "id": 81924,
              "__typename": "File"
            }],
            "id": 1617,
            "name": "6301 BERKMAN bv zv.pdf",
            "document_type": [{
              "id": 86,
              "name": "Zoning Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 235770,
            "name": "6301 BERKMAN DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_code_violation",
          "zv_violations": [{
            "id": "No, there are currently no outstanding Zoning Code Violations on file.",
            "name": "No, there are currently no outstanding Zoning Code Violations on file.",
            "__typename": "ZVViolation"
          }],
          "zv_violations_other": null,
          "__typename": "ZoningCodeViolation"
        }, {
          "id": 31,
          "name": "Property|235770|FireCodeViolation",
          "fv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Fire Code Violations on file.",
            "__typename": "FVViolation"
          }],
          "fv_violations_other": null,
          "document": [{
            "document": [{
              "filename": "6301 BERKMAN.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/6301%20BERKMAN.pdf",
              "id": 81925,
              "__typename": "File"
            }],
            "id": 1618,
            "name": "6301 BERKMAN.pdf",
            "document_type": [{
              "id": 92,
              "name": "Fire Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-03-07",
          "notes": null,
          "permit_number": null,
          "property": [{
            "id": 235770,
            "name": "6301 BERKMAN DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "fire_code_violation",
          "__typename": "FireCodeViolation"
        }, {
          "id": 32,
          "name": "Property|1325841|ZoningLetter",
          "letter_date": "2022-01-25",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "SummerCreek Apartments ZL ZV BV FV.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/SummerCreek%20Apartments%20ZL%20ZV%20BV%20FV.pdf",
              "id": 81983,
              "__typename": "File"
            }],
            "id": 1621,
            "name": "SummerCreek Apartments ZL ZV BV FV.pdf",
            "document_type": [{
              "id": 85,
              "name": "Zoning Letter",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 1325841,
            "name": "11851 BELAIR DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_letter",
          "__typename": "ZoningLetter"
        }, {
          "id": 33,
          "name": "Property|1325841|BuildingCodeViolation",
          "notes": null,
          "bv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Building Code Violations on file",
            "__typename": "BVViolation"
          }],
          "bv_violations_other": null,
          "letter_date": "2022-01-25",
          "document": [{
            "document": [{
              "filename": "SummerCreek Apartments ZL ZV BV FV.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/SummerCreek%20Apartments%20ZL%20ZV%20BV%20FV_0.pdf",
              "id": 81984,
              "__typename": "File"
            }],
            "id": 1622,
            "name": "SummerCreek Apartments ZL ZV BV FV.pdf",
            "document_type": [{
              "id": 87,
              "name": "Building Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 1325841,
            "name": "11851 BELAIR DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "building_code_violation",
          "__typename": "BuildingCodeViolation"
        }, {
          "id": 34,
          "name": "Property|1325841|ZoningCodeViolation",
          "letter_date": "2022-01-25",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "SummerCreek Apartments ZL ZV BV FV.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/SummerCreek%20Apartments%20ZL%20ZV%20BV%20FV_1.pdf",
              "id": 81985,
              "__typename": "File"
            }],
            "id": 1623,
            "name": "SummerCreek Apartments ZL ZV BV FV.pdf",
            "document_type": [{
              "id": 86,
              "name": "Zoning Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 1325841,
            "name": "11851 BELAIR DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_code_violation",
          "zv_violations": [{
            "id": "No, there are currently no outstanding Zoning Code Violations on file.",
            "name": "No, there are currently no outstanding Zoning Code Violations on file.",
            "__typename": "ZVViolation"
          }],
          "zv_violations_other": null,
          "__typename": "ZoningCodeViolation"
        }, {
          "id": 35,
          "name": "Property|1325841|FireCodeViolation",
          "fv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Fire Code Violations on file.",
            "__typename": "FVViolation"
          }],
          "fv_violations_other": null,
          "document": [{
            "document": [{
              "filename": "SummerCreek Apartments ZL ZV BV FV.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/SummerCreek%20Apartments%20ZL%20ZV%20BV%20FV_2.pdf",
              "id": 82050,
              "__typename": "File"
            }],
            "id": 1628,
            "name": "SummerCreek Apartments ZL ZV BV FV.pdf",
            "document_type": [{
              "id": 92,
              "name": "Fire Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-01-25",
          "notes": null,
          "permit_number": null,
          "property": [{
            "id": 1325841,
            "name": "11851 BELAIR DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "fire_code_violation",
          "__typename": "FireCodeViolation"
        }, {
          "id": 36,
          "name": "Property|1325841|Condemnation",
          "cn_plans": [{
            "id": "No, there are currently no known Condemnation Plans at this time.",
            "name": "No, there are currently no known Condemnation Plans at this time.",
            "__typename": "CNPlan"
          }],
          "cn_plans_other": null,
          "document": [{
            "document": [{
              "filename": "11851 BELAIR CN.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/11851%20BELAIR%20CN.pdf",
              "id": 82051,
              "__typename": "File"
            }],
            "id": 1629,
            "name": "11851 BELAIR CN.pdf",
            "document_type": [{
              "id": 90,
              "name": "Condemnation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-01-26",
          "notes": null,
          "property": [{
            "id": 1325841,
            "name": "11851 BELAIR DR",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "condemnation",
          "__typename": "Condemnation"
        }, {
          "id": 37,
          "name": "Property|2282493|Condemnation",
          "cn_plans": [{
            "id": "No, there are currently no known Condemnation Plans at this time.",
            "name": "No, there are currently no known Condemnation Plans at this time.",
            "__typename": "CNPlan"
          }],
          "cn_plans_other": null,
          "document": [{
            "document": [{
              "filename": "The Overland cn.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/The%20Overland%20cn.pdf",
              "id": 82091,
              "__typename": "File"
            }],
            "id": 1649,
            "name": "The Overland cn.pdf",
            "document_type": [{
              "id": 90,
              "name": "Condemnation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-01-20",
          "notes": null,
          "property": [{
            "id": 2282493,
            "name": "2065 S Cherokee St",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "condemnation",
          "__typename": "Condemnation"
        }, {
          "id": 38,
          "name": "Property|2282493|FireCodeViolation",
          "fv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Fire Code Violations on file.",
            "__typename": "FVViolation"
          }],
          "fv_violations_other": null,
          "document": [{
            "document": [{
              "filename": "The Overland fv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/The%20Overland%20fv.pdf",
              "id": 82092,
              "__typename": "File"
            }],
            "id": 1650,
            "name": "The Overland fv.pdf",
            "document_type": [{
              "id": 92,
              "name": "Fire Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-01-31",
          "notes": null,
          "permit_number": null,
          "property": [{
            "id": 2282493,
            "name": "2065 S Cherokee St",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "fire_code_violation",
          "__typename": "FireCodeViolation"
        }, {
          "id": 39,
          "name": "Property|2282493|BuildingCodeViolation",
          "notes": null,
          "bv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Building Code Violations on file",
            "__typename": "BVViolation"
          }],
          "bv_violations_other": null,
          "letter_date": "2022-01-31",
          "document": [{
            "document": [{
              "filename": "The Overland bv zv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/The%20Overland%20bv%20zv.pdf",
              "id": 82094,
              "__typename": "File"
            }],
            "id": 1652,
            "name": "The Overland bv zv.pdf",
            "document_type": [{
              "id": 87,
              "name": "Building Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 2282493,
            "name": "2065 S Cherokee St",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "building_code_violation",
          "__typename": "BuildingCodeViolation"
        }, {
          "id": 40,
          "name": "Property|2282493|ZoningCodeViolation",
          "letter_date": "2022-01-31",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "The Overland bv zv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/The%20Overland%20bv%20zv_0.pdf",
              "id": 82095,
              "__typename": "File"
            }],
            "id": 1653,
            "name": "The Overland bv zv.pdf",
            "document_type": [{
              "id": 86,
              "name": "Zoning Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 2282493,
            "name": "2065 S Cherokee St",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_code_violation",
          "zv_violations": [{
            "id": "No, there are currently no outstanding Zoning Code Violations on file.",
            "name": "No, there are currently no outstanding Zoning Code Violations on file.",
            "__typename": "ZVViolation"
          }],
          "zv_violations_other": null,
          "__typename": "ZoningCodeViolation"
        }, {
          "id": 41,
          "name": "Property|2282493|ZoningLetter",
          "letter_date": "2022-01-20",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "The Overland zl.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/The%20Overland%20zl.pdf",
              "id": 82096,
              "__typename": "File"
            }],
            "id": 1654,
            "name": "The Overland zl.pdf",
            "document_type": [{
              "id": 85,
              "name": "Zoning Letter",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 2282493,
            "name": "2065 S Cherokee St",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_letter",
          "__typename": "ZoningLetter"
        }, {
          "id": 42,
          "name": "Property|12112851|Condemnation",
          "building_number": null,
          "co_date": "2022-06-15",
          "co_number": "test",
          "document": [{
            "document": [{
              "filename": "2864 dublin.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/2864%20dublin.pdf",
              "id": 82309,
              "__typename": "File"
            }],
            "id": 1675,
            "name": "2864 dublin.pdf",
            "document_type": [{
              "id": 89,
              "name": "Certificate of Occupancy",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "notes": null,
          "parking_required": null,
          "property": [{
            "id": 12112851,
            "name": "2864 DUBLIN BLVD",
            "__typename": "Property"
          }],
          "provider": [],
          "square_footage": null,
          "tenant": [],
          "type": "certificate_of_occupancy",
          "use": [{
            "id": 26298,
            "name": "Multi-Family Dwelling",
            "__typename": "Use"
          }],
          "__typename": "CertificateOfOccupancy"
        }, {
          "id": 43,
          "name": "Property|2807532|Condemnation",
          "building_number": null,
          "co_date": null,
          "co_number": null,
          "document": [{
            "document": [{
              "filename": "2311 ANZIO DR CO.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/2311%20ANZIO%20DR%20CO.pdf",
              "id": 82737,
              "__typename": "File"
            }],
            "id": 1694,
            "name": "2311 ANZIO DR CO.pdf",
            "document_type": [{
              "id": 89,
              "name": "Certificate of Occupancy",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "notes": "u003Cpu003EAll u0026nbsp;CofOu0027s are attachedu003C/pu003E",
          "parking_required": null,
          "property": [{
            "id": 2807532,
            "name": "2311 ANZIO DR",
            "__typename": "Property"
          }],
          "provider": [],
          "square_footage": null,
          "tenant": [],
          "type": "certificate_of_occupancy",
          "use": [{"id": 5586, "name": "Multifamily", "__typename": "Use"}],
          "__typename": "CertificateOfOccupancy"
        }, {
          "id": 44,
          "name": "Property|20704937|ZoningLetter",
          "letter_date": "2022-03-24",
          "notes": "u003Cpu003ETiffany Chhanu003C/pu003E",
          "document": [{
            "document": [{
              "filename": "3111 North Tustin Avenue ZL.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/3111%20North%20Tustin%20Avenue%20ZL.pdf",
              "id": 82917,
              "__typename": "File"
            }],
            "id": 1696,
            "name": "3111 North Tustin Avenue ZL.pdf",
            "document_type": [{
              "id": 85,
              "name": "Zoning Letter",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 20704937,
            "name": " 3111 North Tustin Avenue",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_letter",
          "__typename": "ZoningLetter"
        }, {
          "id": 45,
          "name": "Property|20704937|Condemnation",
          "building_number": null,
          "co_date": null,
          "co_number": null,
          "document": [{
            "document": [{
              "filename": "3111 North Tustin AvenueCO.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/3111%20North%20Tustin%20AvenueCO.pdf",
              "id": 82919,
              "__typename": "File"
            }],
            "id": 1697,
            "name": "3111 North Tustin AvenueCO.pdf",
            "document_type": [{
              "id": 89,
              "name": "Certificate of Occupancy",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "notes": null,
          "parking_required": null,
          "property": [{
            "id": 20704937,
            "name": " 3111 North Tustin Avenue",
            "__typename": "Property"
          }],
          "provider": [],
          "square_footage": null,
          "tenant": [],
          "type": "certificate_of_occupancy",
          "use": [],
          "__typename": "CertificateOfOccupancy"
        }, {
          "id": 46,
          "name": "Property|20704937|BuildingCodeViolation",
          "notes": null,
          "bv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Building Code Violations on file",
            "__typename": "BVViolation"
          }],
          "bv_violations_other": null,
          "letter_date": "2022-03-24",
          "document": [{
            "document": [{
              "filename": "3111 North Tustin Avenue BV ZV.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/3111%20North%20Tustin%20Avenue%20BV%20ZV.pdf",
              "id": 82920,
              "__typename": "File"
            }],
            "id": 1698,
            "name": "3111 North Tustin Avenue BV ZV.pdf",
            "document_type": [{
              "id": 87,
              "name": "Building Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 20704937,
            "name": " 3111 North Tustin Avenue",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "building_code_violation",
          "__typename": "BuildingCodeViolation"
        }, {
          "id": 47,
          "name": "Property|20704937|ZoningCodeViolation",
          "letter_date": "2022-03-24",
          "notes": null,
          "document": [{
            "document": [{
              "filename": "3111 North Tustin Avenue BV ZV.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/3111%20North%20Tustin%20Avenue%20BV%20ZV_0.pdf",
              "id": 82921,
              "__typename": "File"
            }],
            "id": 1699,
            "name": "3111 North Tustin Avenue BV ZV.pdf",
            "document_type": [{
              "id": 86,
              "name": "Zoning Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "property": [{
            "id": 20704937,
            "name": " 3111 North Tustin Avenue",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "zoning_code_violation",
          "zv_violations": [{
            "id": "No, there are currently no outstanding Zoning Code Violations on file.",
            "name": "No, there are currently no outstanding Zoning Code Violations on file.",
            "__typename": "ZVViolation"
          }],
          "zv_violations_other": null,
          "__typename": "ZoningCodeViolation"
        }, {
          "id": 48,
          "name": "Property|20704937|FireCodeViolation",
          "fv_violations": [{
            "id": "No",
            "name": "No, there are currently no outstanding Fire Code Violations on file.",
            "__typename": "FVViolation"
          }],
          "fv_violations_other": null,
          "document": [{
            "document": [{
              "filename": "3111 North Tustin Avenue fv.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/3111%20North%20Tustin%20Avenue%20fv.pdf",
              "id": 82923,
              "__typename": "File"
            }],
            "id": 1700,
            "name": "3111 North Tustin Avenue fv.pdf",
            "document_type": [{
              "id": 92,
              "name": "Fire Code Violation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-03-28",
          "notes": null,
          "permit_number": null,
          "property": [{
            "id": 20704937,
            "name": " 3111 North Tustin Avenue",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "fire_code_violation",
          "__typename": "FireCodeViolation"
        }, {
          "id": 49,
          "name": "Property|20704937|Condemnation",
          "cn_plans": [{
            "id": "No, there are currently no known Condemnation Plans at this time.",
            "name": "No, there are currently no known Condemnation Plans at this time.",
            "__typename": "CNPlan"
          }],
          "cn_plans_other": null,
          "document": [{
            "document": [{
              "filename": "3111 North Tustin Avenue cn.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/3111%20North%20Tustin%20Avenue%20cn.pdf",
              "id": 82924,
              "__typename": "File"
            }],
            "id": 1701,
            "name": "3111 North Tustin Avenue cn.pdf",
            "document_type": [{
              "id": 90,
              "name": "Condemnation",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": "2022-03-25",
          "notes": null,
          "property": [{
            "id": 20704937,
            "name": " 3111 North Tustin Avenue",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "condemnation",
          "__typename": "Condemnation"
        }, {
          "id": 50,
          "name": "Property|20704937|Variance",
          "document": [{
            "document": [{
              "filename": "3111 North Tustin Avenue var.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/3111%20North%20Tustin%20Avenue%20var.pdf",
              "id": 82926,
              "__typename": "File"
            }],
            "id": 1702,
            "name": "3111 North Tustin Avenue var.pdf",
            "document_type": [{
              "id": 95,
              "name": "Variance",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "letter_date": null,
          "notes": null,
          "variance_number": null,
          "property": [{
            "id": 20704937,
            "name": " 3111 North Tustin Avenue",
            "__typename": "Property"
          }],
          "provider": [],
          "type": "variance",
          "__typename": "Variance"
        }, {
          "id": 51,
          "name": "Property|17797374|Condemnation",
          "building_number": null,
          "co_date": "2005-06-03",
          "co_number": null,
          "document": [{
            "document": [{
              "filename": "3000 FM 646 CO.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/3000%20FM%20646%20CO.pdf",
              "id": 81724,
              "__typename": "File"
            }],
            "id": 1576,
            "name": "3000 FM 646 CO.pdf",
            "document_type": [{
              "id": 89,
              "name": "Certificate of Occupancy",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "notes": null,
          "parking_required": null,
          "property": [{
            "id": 17797374,
            "name": "3000 FM 646 East",
            "__typename": "Property"
          }],
          "provider": [],
          "square_footage": null,
          "tenant": [{
            "id": 1495,
            "name": "League City Storage",
            "__typename": "Tenant"
          }],
          "type": "certificate_of_occupancy",
          "use": [],
          "__typename": "CertificateOfOccupancy"
        }, {
          "id": 52,
          "name": "Property|1325841|Condemnation",
          "building_number": null,
          "co_date": "1981-10-02",
          "co_number": "15301A",
          "document": [{
            "document": [{
              "filename": "1.pdf",
              "filepath": "https://zoning-ddev.ddev.site/sites/default/files/2022-06/1.pdf",
              "id": 83543,
              "__typename": "File"
            }],
            "id": 1726,
            "name": "1.pdf",
            "document_type": [{
              "id": 89,
              "name": "Certificate of Occupancy",
              "__typename": "TaxonomyTerm"
            }],
            "__typename": "MediaDocument"
          }],
          "notes": "u003Cpu003EBldg 1u003C/pu003E",
          "parking_required": null,
          "property": [{
            "id": 1325841,
            "name": "11851 BELAIR DR",
            "__typename": "Property"
          }],
          "provider": [],
          "square_footage": null,
          "tenant": [],
          "type": "certificate_of_occupancy",
          "use": [{
            "id": 62268,
            "name": "Dwelling - Multi-Family (33 Units/Acre Maximim)",
            "__typename": "Use"
          }],
          "__typename": "CertificateOfOccupancy"
        }], "__typename": "ResearchDocumentConnection"
      }
    }));
});

export const MockGetCommercialQueueItems = () => graphql.query('getCommercialQueueItems', (req, res, ctx) => {
  const { limit, offset } = req.variables;

  let items = [
    {
      "id": 1,
      "state": "pending",
      "total_price": 100,
      "total_paid": 100,
      "subtotal_price": 100,
      "placed": "2022-07-20",
      "order_number": "270",
      "order_balance": 0,
      "billing_information": [
        {
          "address": {
            "address_line1": "6810 International Center Blvd",
            "address_line2": ""
          }
        }
      ],
      "client": [
        {
          "id": 1,
          "name": "Admin"
        }
      ],
      "contact_information": null,
      "report_order_items": [
        {
          "id": 1,
          "name": "First Row",
          "address": {
            "address_line1": "1234 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          },
          "__typename": "CommercialReportOrderItem"
        },
        {
          "id": 2,
          "name": "First Row",
          "address": {
            "address_line1": "1234 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          },
          "__typename": "CommercialReportOrderItem"
        }
      ],
      "__typename": "CommercialOrder"
    },
    {
      "id": 2,
      "state": "pending",
      "total_price": 100,
      "total_paid": 100,
      "subtotal_price": 100,
      "placed": "2022-07-20",
      "order_number": "270",
      "order_balance": 0,
      "billing_information": [
        {
          "address": {
            "address_line1": "6810 International Center Blvd",
            "address_line2": ""
          }
        }
      ],
      "client": [
        {
          "id": 1,
          "name": "Admin"
        }
      ],
      "contact_information": null,
      "report_order_items": [
        {
          "id": 3,
          "name": "Second Row",
          "address": {
            "address_line1": "5678 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          },
          "__typename": "CommercialReportOrderItem"
        },
        {
          "id": 4,
          "name": "Second Row",
          "address": {
            "address_line1": "5678 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          },
          "__typename": "CommercialReportOrderItem"
        }
      ],
      "__typename": "CommercialOrder"
    },
    {
      "id": 3,
      "state": "pending",
      "total_price": 100,
      "total_paid": 100,
      "subtotal_price": 100,
      "placed": "2022-07-20",
      "order_number": "270",
      "order_balance": 0,
      "billing_information": [
        {
          "address": {
            "address_line1": "6810 International Center Blvd",
            "address_line2": ""
          }
        }
      ],
      "client": [
        {
          "id": 1,
          "name": "Admin"
        }
      ],
      "contact_information": null,
      "report_order_items": [
        {
          "id": 5,
          "name": "Third Row",
          "address": {
            "address_line1": "91011 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          },
          "__typename": "CommercialReportOrderItem"
        },
        {
          "id": 6,
          "name": "Third Row",
          "address": {
            "address_line1": "91011 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          },
          "__typename": "CommercialReportOrderItem"
        }
      ],
      "__typename": "CommercialOrder"
    },
    {
      "id": 4,
      "state": "pending",
      "total_price": 100,
      "total_paid": 100,
      "subtotal_price": 100,
      "placed": "2022-07-20",
      "order_number": "270",
      "order_balance": 0,
      "billing_information": [
        {
          "address": {
            "address_line1": "6810 International Center Blvd",
            "address_line2": ""
          }
        }
      ],
      "client": [
        {
          "id": 1,
          "name": "Admin"
        }
      ],
      "contact_information": null,
      "report_order_items": [
        {
          "id": 7,
          "name": "Fourth Row",
          "address": {
            "address_line1": "12131415 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          },
          "__typename": "CommercialReportOrderItem"
        },
        {
          "id": 8,
          "name": "Fourth Row",
          "address": {
            "address_line1": "12131415 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          },
          "__typename": "CommercialReportOrderItem"
        }
      ],
      "__typename": "CommercialOrder"
    },
    /*{
      "id": 5,
      "state": "completed",
      "total_price": 100,
      "total_paid": 100,
      "subtotal_price": 100,
      "placed": "2022-07-20",
      "order_number": "270",
      "order_balance": 0,
      "billing_information": [
        {
          "address": {
            "address_line1": "6810 International Center Blvd",
            "address_line2": ""
          }
        }
      ],
      "client": [
        {
          "id": 1,
          "name": "Admin"
        }
      ],
      "contact_information": null,
      "report_order_items": [
        {
          "id": 9,
          "name": "Fifth Row",
          "address": {
            "address_line1": "16171819 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          },
          "__typename": "CommercialReportOrderItem"
        },
        {
          "id": 10,
          "name": "Fifth Row",
          "address": {
            "address_line1": "16171819 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          },
          "__typename": "CommercialReportOrderItem"
        }
      ],
      "__typename": "CommercialOrder"
    },*/
  ]

  /*const items = [{
    "id": 270,
    "state": "completed",
    "total_price": 100,
    "total_paid": 100,
    "subtotal_price": 100,
    "placed": "2022-07-20",
    "order_number": "270",
    "order_balance": 0,
    "billing_information": [{
      "address": {
        "address_line1": "6810 International Center Blvd",
        "address_line2": "",
        "administrative_area": "FL",
        "country_code": "US",
        "locality": "Fort Myers",
        "postal_code": "33912",
      },
    }],
    "client": [{"id": 1202, "name": "LSI Companies", "__typename": "User"}],
    "contact_information": null,
    "report_order_items": [{
      "id": 1216,
      "name": "Address Report",
      "property": [],
      "__typename": "CommercialReportOrderItem"
    }, {
      "id": 1217,
      "name": "Address Report",
      "property": [],
      "__typename": "CommercialReportOrderItem"
    }],
    "__typename": "CommercialOrder"
  }]*/

  return res(
    ctx.data({
      "commercialQueueItems": {
        "items": items.slice(offset, offset + limit),
        "__typename": "CommercialQueueConnection",
        total: Math.min(items.length, limit),
      }
    })
  )
});

export const MockGetCommercialClaimedQueueItems = () => graphql.query('getCommercialClaimedQueueItems', (req, res, ctx) => {
  const { limit, offset } = req.variables;

  let items = [
    {
      "id": 1,
      "state": "pending",
      "total_price": 100,
      "total_paid": 100,
      "subtotal_price": 100,
      "placed": "2022-07-20",
      "order_number": "270",
      "order_balance": 0,
      "billing_information": [
        {
          "address": {
            "address_line1": "6810 International Center Blvd",
            "address_line2": ""
          }
        }
      ],
      "client": [
        {
          "id": 1,
          "name": "Admin"
        }
      ],
      "contact_information": null,
      "report_order_items": [
        {
          "id": 1,
          "name": "First Row",
          "address": {
            "address_line1": "1234 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          }
        },
        {
          "id": 2,
          "name": "First Row",
          "address": {
            "address_line1": "1234 Best Dr",
            "address_line2": "",
            "administrative_area": "SC",
            "country_code": "US",
            "locality": "Rockhill",
            "postal_code": "12345",
          }
        }
      ]
    },
  ]

  let realLimit = limit ?? 25;
  let realOffset = offset ?? 0;

  return res(
    ctx.data({
      "commercialClaimedQueueItems": {
        "items": items.slice(realOffset, realOffset + realLimit),
        total: Math.min(items.length, realLimit),
      }
    })
  );
});

export const MockGetCommercialOrder = () => graphql.query('getCommercialOrder', (req, res, ctx) => {
  const { id } = req.variables;

  return res(
    ctx.data({
      "commercialOrder": {
        "id": id,
        "state": "pending",
        "total_price": 100,
        "total_paid": 100,
        "subtotal_price": 100,
        "placed": "2022-07-20",
        "order_number": "270",
        "order_balance": 0,
        "billing_information": [
          {
            "address": {
              "address_line1": "6810 International Center Blvd",
              "address_line2": ""
            }
          }
        ],
        "client": [
          {
            "id": 1,
            "name": "Admin"
          }
        ],
        "contact_information": null,
        "report_order_items": [
          {
            "id": 1,
            "name": "First Row",
            "address": {
              "address_line1": "1234 Best Dr",
              "address_line2": "",
              "administrative_area": "SC",
              "country_code": "US",
              "locality": "Rockhill",
              "postal_code": "12345",
            },
            property: [],
            report_type: "Property Requirements Report",
            status: "pending",
          },
          {
            "id": 2,
            "name": "First Row",
            "address": {
              "address_line1": "1234 Best Dr",
              "address_line2": "",
              "administrative_area": "SC",
              "country_code": "US",
              "locality": "Rockhill",
              "postal_code": "12345",
            },
            property: [{
              id: 1,
              name: "A test property",
              zone: [{
                id: 1,
                name: 'testZone',
              }]
            }],
            report_type: "Use Allowance Report",
            status: "working",
          },
        ]
      }
    })
  );
});

export const MockGetCommercialReportItem = () => graphql.query('getCommercialReportItem', (req, res, ctx) => {
  const { id } = req.variables;

  switch(id) {
    case 2:
      return res(
        ctx.data({
          commercialReportItem: {
            "id": id,
            "name": "Second Row",
            "address": {
              "address_line1": "1234 Best Dr",
              "address_line2": "",
              "administrative_area": "SC",
              "country_code": "US",
              "locality": "Rockhill",
              "postal_code": "12345",
            },
            /*jurisdiction: [{
              "id": 1,
              "name": "United States",
              "type": "country",
              "verified_date": Math.floor(new Date().getTime() / 1000),
              "verification_state": null,
              "task_description": null,
            }],*/
            property: [propertyList[0]],
            quantity:1,
            total_price:50,
            unit_price:50,
          }
        })
      );
    default:
      return res(
        ctx.data({
          commercialReportItem: {
            "id": id,
            "name": "First Row",
            "address": {
              "address_line1": "1234 Best Dr",
              "address_line2": "",
              "administrative_area": "SC",
              "country_code": "US",
              "locality": "Rockhill",
              "postal_code": "12345",
            },
            property: [],
            quantity:1,
            total_price:50,
            unit_price:50,
          }
        })
      );
  }
});

export const MockProperties = () => graphql.query('properties', (req, res, ctx) => {
  const { name, jurisdiction, limit, offset } = req.variables;

  let items = propertyList

  switch(jurisdiction) {
    case 4:
    case 2:
    case 1:
      return res(
        ctx.data({
          "properties": {
            "count": items.filter((item) => {
              if(name === "") {
                return true
              }
              return item.name.includes(name)
            }).length,
            "items": items.filter((item) => {
              if(name === "") {
                return true
              }
              return item.name.includes(name)
            }).slice(offset, offset + limit),
          }
        })
      );
    default: return res(ctx.data({
      "properties": {
        "count": 4,
        "items": [{
          "abutting_zoning": [{
            "id": 48161,
            "name": null,
            "zoning": [],
            "__typename": "AbuttingZoning"
          }],
          "address": {
            "additional_name": "",
            "address_line1": "2017 N Front St",
            "address_line2": "",
            "administrative_area": "PA",
            "country_code": "US",
            "dependent_locality": "",
            "family_name": "",
            "given_name": "",
            "langcode": "",
            "locality": "Philadelphia",
            "organization": "",
            "postal_code": "19122",
            "sorting_code": "",
            "__typename": "Address"
          },
          "id": 20714397,
          "name": "2017 N Front St",
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "google_map": [],
          "notes": null,
          "parcel_map": [],
          "parcel_tax_id": null,
          "use": [],
          "zone": [{
            "id": 7876,
            "name": "Neighborhood Commercial Mixed-Use District-2.5",
            "__typename": "Zone"
          }],
          "zoning_map": [],
          "__typename": "Property"
        }, {
          "abutting_zoning": [{
            "id": 48162,
            "name": null,
            "zoning": [],
            "__typename": "AbuttingZoning"
          }],
          "address": {
            "additional_name": "",
            "address_line1": "1721-1723 Ridge Ave",
            "address_line2": "",
            "administrative_area": "PA",
            "country_code": "US",
            "dependent_locality": "",
            "family_name": "",
            "given_name": "",
            "langcode": "",
            "locality": "Philadelphia",
            "organization": "",
            "postal_code": "19130",
            "sorting_code": "",
            "__typename": "Address"
          },
          "id": 20714398,
          "name": "1721-1723 Ridge Ave",
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "google_map": [],
          "notes": null,
          "parcel_map": [],
          "parcel_tax_id": null,
          "use": [{"id": 64942, "name": "Multi-Family", "__typename": "Use"}],
          "zone": [{
            "id": 7876,
            "name": "Neighborhood Commercial Mixed-Use District-2.5",
            "__typename": "Zone"
          }],
          "zoning_map": [],
          "__typename": "Property"
        }, {
          "abutting_zoning": [{
            "id": 51490,
            "name": null,
            "zoning": [],
            "__typename": "AbuttingZoning"
          }],
          "address": {
            "additional_name": "",
            "address_line1": "1390 Schuylkill Avenue",
            "address_line2": "",
            "administrative_area": "PA",
            "country_code": "US",
            "dependent_locality": "",
            "family_name": "",
            "given_name": "",
            "langcode": "",
            "locality": "Philadelphia",
            "organization": "",
            "postal_code": "19145",
            "sorting_code": "",
            "__typename": "Address"
          },
          "id": 20714500,
          "name": "1390 Schuylkill Avenue",
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "google_map": [],
          "notes": null,
          "parcel_map": [],
          "parcel_tax_id": null,
          "use": [],
          "zone": [{
            "id": 7886,
            "name": "Heavy Industrial District ",
            "__typename": "Zone"
          }],
          "zoning_map": [],
          "__typename": "Property"
        }, {
          "abutting_zoning": [{
            "id": 51585,
            "name": null,
            "zoning": [],
            "__typename": "AbuttingZoning"
          }],
          "address": {
            "additional_name": "",
            "address_line1": "9801 Blue Grass Road",
            "address_line2": "",
            "administrative_area": "PA",
            "country_code": "US",
            "dependent_locality": "",
            "family_name": "",
            "given_name": "",
            "langcode": "",
            "locality": "Philadelphia",
            "organization": "",
            "postal_code": "19114",
            "sorting_code": "",
            "__typename": "Address"
          },
          "id": 20714507,
          "name": "9801 Blue Grass Road",
          "jurisdiction": [{
            "id": 16760,
            "name": "Philadelphia - Philadelphia - Pennsylvania",
            "__typename": "Locality"
          }],
          "google_map": [],
          "notes": null,
          "parcel_map": [],
          "parcel_tax_id": null,
          "use": [],
          "zone": [{
            "id": 7884,
            "name": "Light Industrial District ",
            "__typename": "Zone"
          }, {
            "id": 7904,
            "name": "Far Northeast Overlay ",
            "__typename": "Overlay"
          }, {
            "id": 7902,
            "name": "Airport Hazard Control Overlay ",
            "__typename": "Overlay"
          }, {
            "id": 7905,
            "name": "Northeast Overlay ",
            "__typename": "Overlay"
          }],
          "zoning_map": [],
          "__typename": "Property"
        }],
        "__typename": "PropertyConnection"
      }
    }))
  }
});

export const MockGetJurisdictions = () => graphql.query('getJurisdictionOptions', (req, res, ctx) => {
  const { limit, offset, name } = req.variables;

  return res(
    ctx.data({"jurisdictions":{"items": jurisdictionList.filter(item => item.name.includes(name)).slice(offset, offset + limit)}})
  );
});

//there currently don't do anything because their responses are not processed by the app.
export const MockEditOrderItem = () => graphql.mutation('editOrderItem', (req, res, ctx) => {
  //const { limit, offset, name } = req.variables;

  return res(
    ctx.data({})
  );
});

export const MockCreateProperty = () => graphql.mutation('createProperty', (req, res, ctx) => {
  //const { limit, offset, name } = req.variables;

  return res(
    ctx.data({
      "createProperty": {
        "errors": [],
        "property": {
          "id": 1,
          "name": "This is a test Property",
          "jurisdiction": [{
            "id": 1,
            "name": "United States",
            "verified_date": Math.floor(new Date().getTime() / 1000),
            "verification_state": null,
            "type": 'administrative_area',
            "__typename": "Country"
          }],
          "__typename": "Property"
        },
        "__typename": "PropertyResponse"
      }
    })
  );
});

export const MockEditProperty = () => graphql.mutation('editProperty', (req, res, ctx) => {
  //const { limit, offset, name } = req.variables;

  return res(
    ctx.data({
      "editProperty": {
        "errors": [],
        "property": {
          "id": 1,
          "name": "This is a test Property 2",
          "jurisdiction": [{
            "id": 1,
            "name": "United States",
            "verified_date": Math.floor(new Date().getTime() / 1000),
            "verification_state": null,
            "type": 'administrative_area',
            "__typename": "Country"
          }],
          "__typename": "Property"
        },
        "__typename": "PropertyResponse"
      }
    })
  );
});

export const MockEditJurisdiction = () => graphql.mutation('editJurisdiction', (req, res, ctx) => {
  //const { limit, offset, name } = req.variables;

  return res(
    ctx.data({})
  );
});

export const MockGenerateCommercialReport = () => graphql.mutation('generateCommercialReport', (req, res, ctx) => {
  //const { limit, offset, name } = req.variables;

  return res(
    ctx.data({})
  );
});
